(function () {
  'use strict';

  if (window.__hhPdpRuntime) {
    window.__hhPdpRuntime.mount(document);
    return;
  }
  var ownedRoots = [];

  function createOwner(root) {
    var cleanups = [];
    var owner = {
      destroyed: false,
      onCleanup: function (cleanup) {
        if (typeof cleanup !== 'function') return;
        if (owner.destroyed) cleanup();
        else cleanups.push(cleanup);
      },
      listen: function (target, type, handler, options) {
        if (!target || typeof target.addEventListener !== 'function' || owner.destroyed) return;
        var guarded = function (event) {
          if (!owner.destroyed) return handler(event);
        };
        target.addEventListener(type, guarded, options);
        owner.onCleanup(function () { target.removeEventListener(type, guarded, options); });
      },
      destroy: function () {
        if (owner.destroyed) return;
        owner.destroyed = true;
        // A failing app cleanup must not prevent the remaining resources
        // from being released. Surface it, without touching another app.
        cleanups.reverse().forEach(function (cleanup) {
          try { cleanup(); }
          catch (error) { if (window.console) window.console.error('HealthyHey PDP cleanup failed', error); }
        });
        cleanups = [];
        if (root.__hhPdpController === owner) delete root.__hhPdpController;
        ownedRoots = ownedRoots.filter(function (entry) { return entry !== root; });
      }
    };
    root.__hhPdpController = owner;
    ownedRoots.push(root);
    return owner;
  }

  function init(root) {
    if (!root) return null;
    if (root.__hhPdpController && !root.__hhPdpController.destroyed) return root.__hhPdpController;
    var owner = createOwner(root);
    var listen = owner.listen;
    try {
    var productId = root.getAttribute('data-product-id');
    var rightToKnow = root.querySelector('[data-hh-crtk]');
    var rightToKnowLink = rightToKnow ? rightToKnow.querySelector('.hh-crtk__link') : null;
    var rightToKnowMap = rightToKnow ? rightToKnow.querySelector('[data-hh-crtk-variants]') : null;
    var rightToKnowUrls = {};
    try { rightToKnowUrls = rightToKnowMap ? JSON.parse(rightToKnowMap.textContent) || {} : {}; }
    catch (e) { rightToKnowUrls = {}; }
    function updateRightToKnow(variantId) {
      if (!rightToKnow || !rightToKnowLink) return;
      var url = rightToKnowUrls[String(variantId)] || rightToKnow.getAttribute('data-hh-crtk-fallback') || '';
      rightToKnow.hidden = !url;
      if (url) rightToKnowLink.setAttribute('href', url);
      else rightToKnowLink.removeAttribute('href');
    }
    var variantsEl = root.querySelector('[data-hh-pdp-variants]');
    var galleryMapEl = root.querySelector('[data-hh-pdp-gallery-map]');
    var packsEl = root.querySelector('[data-hh-pdp-packs]');
    var typedPresenceEl = root.querySelector('[data-hh-pdp-typed-presence]');
    var typedPresence = {};
    try { typedPresence = typedPresenceEl ? JSON.parse(typedPresenceEl.textContent) || {} : {}; }
    catch (e) { typedPresence = {}; }
    var reassuranceEl = root.querySelector('[data-hh-pdp-reassurance]');
    var reassuranceDefaults = root.querySelector('[data-hh-pdp-reassurance-defaults]');
    var purchaseComparisonEl = root.querySelector('[data-hh-pdp-purchase-comparison]');
    var purchaseComparisonDefaults = root.querySelector('[data-hh-pdp-purchase-comparison-defaults]');
    var moneyEl = root.querySelector('[data-hh-pdp-money]');
    var alternativesMapEl = root.querySelector('[data-hh-pdp-alternatives-map]');
    var capsuleMediaEl = root.querySelector('[data-hh-pdp-capsule-media]');
    var usageLabelsEl = root.querySelector('[data-hh-pdp-usage-labels]');
    var faqLabelsEl = root.querySelector('[data-hh-pdp-faq-labels]');

    var variants = [];
    var galleryMap = {};
    var packs = {};
    var moneyByVariant = {};
    var alternativesMap = {};
    var capsuleMedia = null;
    try {
      variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    } catch (e) {
      variants = [];
    }
    try {
      galleryMap = galleryMapEl ? JSON.parse(galleryMapEl.textContent) : {};
    } catch (e) {
      galleryMap = {};
    }
    if (!galleryMap) galleryMap = {};
    try {
      packs = packsEl ? JSON.parse(packsEl.textContent) : {};
    } catch (e) {
      packs = {};
    }
    if (!packs) packs = {};
    try {
      moneyByVariant = moneyEl ? JSON.parse(moneyEl.textContent) : {};
    } catch (e) {
      moneyByVariant = {};
    }
    if (!moneyByVariant) moneyByVariant = {};
    try {
      alternativesMap = alternativesMapEl ? JSON.parse(alternativesMapEl.textContent) : {};
    } catch (e) {
      alternativesMap = {};
    }
    if (!alternativesMap) alternativesMap = {};
    try {
      capsuleMedia = capsuleMediaEl ? JSON.parse(capsuleMediaEl.textContent) : null;
    } catch (e) {
      capsuleMedia = null;
    }
    // Resolved once in sections/hh-pdp.liquid from this product's two
    // capsule colour metafields against its approved capsule_video
    // blocks — a missing/unmatched pair means no capsule panel for any
    // pack on this product, never a fallback to the wrong colour's video.
    if (!capsuleMedia || !capsuleMedia.src || !capsuleMedia.poster) capsuleMedia = null;
    // section.settings.image_only (data-hh-pdp-image-only on the root): this
    // PDP shows no video at all. Defense in depth mirroring the Liquid
    // projection in sections/hh-pdp.liquid + snippets/hh-pdp-gallery.liquid
    // item for item — a video item becomes an image of its own poster, in
    // place; an item left without a usable src is dropped rather than
    // rendered with an empty src; an entry that ends up empty keeps a
    // neutral placeholder, never another pack's media; and no capsule panel
    // (nor its lazily-loaded script) can ever be built.
    if (root.getAttribute('data-hh-pdp-image-only') === 'true') {
      var imageOnlyTitle = root.getAttribute('data-product-title') || '';
      Object.keys(galleryMap).forEach(function (variantKey) {
        var entry = galleryMap[variantKey];
        if (!Array.isArray(entry)) return;
        var projected = [];
        entry.forEach(function (item) {
          if (!item) return;
          if (item.type === 'placeholder') {
            projected.push({ type: 'placeholder', alt: item.alt });
            return;
          }
          var src = item.type === 'video' ? item.poster : item.src;
          if (!src) return;
          projected.push({ type: 'image', src: src, alt: item.alt });
        });
        galleryMap[variantKey] = projected.length ? projected : [{ type: 'placeholder', alt: imageOnlyTitle }];
      });
      capsuleMedia = null;
    }
    var usageLabels = { directions: 'Directions', precautions: 'Precautions', storage: 'Storage' };
    try {
      var parsedUsageLabels = usageLabelsEl ? JSON.parse(usageLabelsEl.textContent) : null;
      if (parsedUsageLabels && typeof parsedUsageLabels === 'object') {
        if (parsedUsageLabels.directions) usageLabels.directions = parsedUsageLabels.directions;
        if (parsedUsageLabels.precautions) usageLabels.precautions = parsedUsageLabels.precautions;
        if (parsedUsageLabels.storage) usageLabels.storage = parsedUsageLabels.storage;
      }
    } catch (e) {
      // keep the English fallback labels
    }
    // FAQ disclosure title fallback, used only when an approved pack does
    // not supply its own faq.title. Same JSON-island convention as the
    // usage/capsule labels, so the server render and this rebuild agree.
    var faqLabels = { title: 'Frequently asked questions' };
    try {
      var parsedFaqLabels = faqLabelsEl ? JSON.parse(faqLabelsEl.textContent) : null;
      if (parsedFaqLabels && typeof parsedFaqLabels === 'object' && parsedFaqLabels.title) {
        faqLabels.title = parsedFaqLabels.title;
      }
    } catch (e) {
      // keep the English fallback label
    }

    var select = root.querySelector('[data-hh-pdp-variant-select]');
    var titleEl = root.querySelector('[data-hh-pdp-title]');
    var displayTitle = root.getAttribute('data-hh-pdp-display-title') ||
      root.getAttribute('data-product-title') || '';
    if (titleEl && displayTitle) {
      // Variant Title King also runs on this template and appends the selected
      // pack to matching headings. Keep this PDP's H1 equal to its display title;
      // leave the app's behavior on every other template untouched.
      var restoreDisplayTitle = function () {
        if (titleEl.textContent !== displayTitle) titleEl.textContent = displayTitle;
      };
      restoreDisplayTitle();
      if (typeof MutationObserver !== 'undefined') {
        var titleObserver = new MutationObserver(function () {
          if (!owner.destroyed) restoreDisplayTitle();
        });
        owner.onCleanup(function () { titleObserver.disconnect(); });
        titleObserver.observe(titleEl, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    }
    var pillsWrap = root.querySelector('[data-hh-pdp-variant-pills]');
    var pills = root.querySelectorAll('[data-hh-pdp-variant-pill]');
    var atcButton = root.querySelector('[data-hh-pdp-atc]');
    var atcLabel = root.querySelector('[data-hh-pdp-atc-label]');
    var atcError = root.querySelector('[data-hh-pdp-atc-error]');
    var cartForm = root.querySelector('[data-hh-pdp-form]');
    var commerceLabels = root.querySelector('[data-hh-pdp-commerce-labels]');
    var qtyRow = root.querySelector('[data-hh-pdp-qty-row]');
    var qtyInput = root.querySelector('[data-hh-pdp-qty-input]');
    var nativeQtyState = {
      rowHidden: qtyRow ? qtyRow.hidden : false,
      inputHidden: qtyInput ? qtyInput.hidden : false,
      tabIndex: qtyInput ? qtyInput.getAttribute('tabindex') : null
    };
    var offerSummaryEl = root.querySelector('[data-hh-pdp-offer-summary]');
    var savingsEl = root.querySelector('[data-hh-pdp-savings]');
    var savingsTemplate = savingsEl ? savingsEl.getAttribute('data-hh-pdp-savings-template') || '' : '';
    var currencyCode = (
      root.getAttribute('data-currency') ||
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      ''
    ).toUpperCase();
    var isInrDisplay = currencyCode === 'INR';
    var manualQty = qtyInput ? qtyInput.value : '1';
    if (qtyInput) {
      // Only remember edits the shopper actually made, not values this
      // script writes while an Appstle offer is selected (see
      // refreshOfferDisplay below), so clearing an offer restores what
      // they last typed instead of the offer's quantity.
      listen(qtyInput, 'input', function () {
        manualQty = qtyInput.value;
      });
    }
    var selectedVariantId = (select && select.value) || (function () {
      var activePill = root.querySelector('[data-hh-pdp-variant-pill].is-active');
      return activePill ? activePill.getAttribute('data-variant-id') : null;
    })();
    var initialVariantId = selectedVariantId;
    var productPath = new URL(window.location.href).pathname;
    var restoringHistory = false;
    var priceCurrent = root.querySelector('[data-hh-pdp-price-current]');
    var priceCompare = root.querySelector('[data-hh-pdp-price-compare]');
    var priceAvailability = root.querySelector('[data-hh-pdp-price-availability]');
    var galleryMain = root.querySelector('[data-hh-pdp-gallery-main]');
    var galleryThumbs = root.querySelector('[data-hh-pdp-gallery-thumbs]');
    var galleryTeaser = root.querySelector('[data-hh-pdp-gallery-teaser]');
    var galleryCaption = root.querySelector('[data-hh-pdp-gallery-caption]');
    var galleryPrevBtn = root.querySelector('[data-hh-pdp-gallery-prev]');
    var galleryNextBtn = root.querySelector('[data-hh-pdp-gallery-next]');
    var galleryItemsRef = { items: null };
    var benefitsEl = root.querySelector('[data-hh-pdp-benefits]');
    var storyEl = root.querySelector('[data-hh-pdp-story]');
    // Permanent slot in the purchase column, immediately above Product facts.
    // sections/hh-pdp.liquid always emits it (hidden when this pack has not
    // opted in), so the capsule rebuild below never depends on storyEl.
    var capsuleSlotEl = root.querySelector('[data-hh-pdp-capsule-slot]');
    var benefitEl = root.querySelector('[data-hh-pdp-benefit]');
    var defaultBenefit = benefitEl ? benefitEl.getAttribute('data-default-benefit') || '' : '';
    var highlightEl = root.querySelector('[data-hh-pdp-highlight]');
    var elementalEl = root.querySelector('[data-hh-pdp-elemental]');
    var elementalAmount = root.querySelector('[data-hh-pdp-elemental-amount]');
    var elementalLabel = root.querySelector('[data-hh-pdp-elemental-label]');
    var servingLabel = root.querySelector('[data-hh-pdp-serving-label]');
    var descriptorEl = root.querySelector('[data-hh-pdp-descriptor]');
    var disclosuresEl = root.querySelector('[data-hh-pdp-disclosures]');
    var quickLinks = root.querySelectorAll('[data-hh-pdp-quick]');
    var sectionId = root.getAttribute('data-section-id') || '';
    // Both review-anchor ids are resolved once in sections/hh-pdp.liquid and
    // read back from the root here, so the server render, this rebuild and
    // the hash handling can never disagree. The apps section that carries the
    // review app lives in a JSON template, so its wrapper id has a dynamic
    // 'template--<id>__' prefix and must never be hardcoded.
    var reviewAnchorId = root.getAttribute('data-hh-pdp-review-anchor-id') || '';
    var reviewsAppAnchor = root.getAttribute('data-hh-pdp-reviews-app-anchor') || '';
    var alternativesMount = root.querySelector('[data-hh-pdp-alternatives]');
    var manufacturerSlot = root.querySelector('[data-hh-pdp-manufacturer-slot]');

    function getApprovedPack(variantId) {
      var pack = packs[String(variantId)];
      return pack && pack.approved === true ? pack : null;
    }

    function moneyForVariant(variantId, field) {
      var entry = moneyByVariant[String(variantId)];
      if (entry && entry[field]) return entry[field];
      return null;
    }

    function findVariant(id) {
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === String(id)) return variants[i];
      }
      return null;
    }

    function updateUrl(variantId) {
      if (!window.history || !window.history.replaceState) return;
      var url = new URL(window.location.href);
      if (url.searchParams.get('variant') === String(variantId)) return;
      url.searchParams.set('variant', variantId);
      // Keep existing app-owned history state, query parameters and hash.
      // A deliberate pack choice gets its own entry so Back can restore it.
      var write = window.history.pushState || window.history.replaceState;
      write.call(window.history, window.history.state, '', url.toString());
    }

    function updatePrice(variant) {
      if (!variant) return;
      var currentText = moneyForVariant(variant.id, 'price') || fallbackMoney(variant.price);
      if (priceCurrent) priceCurrent.textContent = currentText;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (priceCompare) {
          priceCompare.hidden = false;
          priceCompare.textContent = 'MRP ';
          var strike = document.createElement('s');
          strike.textContent = moneyForVariant(variant.id, 'compare_at_price') || fallbackMoney(variant.compare_at_price);
          priceCompare.appendChild(strike);
        }
      } else {
        if (priceCompare) priceCompare.hidden = true;
      }
      if (priceAvailability) {
        priceAvailability.textContent = variant.available ? '' : 'Out of stock';
      }
    }

    function ctaMoney(cents, variantId) {
      if (!Number.isFinite(cents)) return '';
      if (isInrDisplay) return inrWholeRupees(cents);
      if (variantId != null) return moneyForVariant(variantId, 'price') || fallbackMoney(cents);
      return fallbackMoney(cents);
    }

    function updateAtc(variant) {
      if (!variant || !atcButton) return;
      atcButton.disabled = !variant.available;
      if (atcLabel) {
        var priceText = ctaMoney(variant.price, variant.id);
        atcLabel.textContent = variant.available ? 'Add to cart · ' + priceText : 'Sold out';
      }
    }

    function isSafePositiveInteger(value) {
      return typeof value === 'number' && Number.isSafeInteger(value) && value > 0;
    }

    // A pack-summary word must be an explicitly authored, non-empty string.
    // A number, a boolean or a whitespace-only value is not a word and
    // resolves to '', which fails the gate below closed.
    function packSummaryWord(value) {
      if (typeof value !== 'string') return '';
      return value.trim();
    }

    // "This pack record states this field at all", independent of whether the
    // stated value is valid. Presence has to be detected separately from
    // validity: a pack that states a malformed units_per_pack must fail
    // closed, never silently fall through to the capsule wording below.
    function isStatedPackField(value) {
      return value !== undefined && value !== null;
    }

    // The only words the legacy contract already implies: capsules_per_pack
    // is a count of capsules in bottles and nothing else. These are never
    // applied to a units_per_pack count.
    var HH_LEGACY_UNIT_PLURAL = 'capsules';
    var HH_LEGACY_PACK_SINGULAR = 'bottle';
    var HH_LEGACY_PACK_PLURAL = 'bottles';

    // Resolves the per-pack unit count and the exact words the summary needs
    // from this one pack's own explicit fields, or null to keep the summary
    // hidden. Two opt-in contracts, neither of them ever inferred from the
    // product title, the variant title or another pack's record:
    //
    //   legacy   capsules_per_pack                     -> 'capsules', 'bottle'/'bottles'
    //   generic  units_per_pack + unit_label_plural     -> those exact words
    //            + pack_label_singular/pack_label_plural
    //
    // The generic contract carries no wording of its own to fall back to: a
    // pack that states units_per_pack without unit_label_plural, or without
    // both container words, hides the summary rather than borrowing the
    // capsule/bottle wording — so a softgel is never called a capsule and a
    // powder is never called a bottle. The container pair is also accepted on
    // a legacy capsule pack, as a pair, to override bottle/bottles. A pack
    // may state both counts (an approved capsule pack can keep
    // capsules_per_pack while adopting explicit words) only when they are the
    // same number: two different counts are contradictory authoring, not a
    // count to choose between.
    //
    // bottle/bottles is a default only where BOTH container fields are
    // entirely absent from a legacy record. A container field that is stated
    // but malformed (a number, a boolean, '', whitespace) is authoring to fix,
    // not an unstated field, so it hides the summary instead of quietly
    // printing the legacy bottle words over it.
    function resolvePackSummaryUnits(pack) {
      if (!pack) return null;
      var hasGeneric = isStatedPackField(pack.units_per_pack);
      var hasLegacy = isStatedPackField(pack.capsules_per_pack);
      if (!hasGeneric && !hasLegacy) return null;
      var perPack = hasGeneric ? pack.units_per_pack : pack.capsules_per_pack;
      if (!isSafePositiveInteger(perPack)) return null;
      if (hasGeneric && hasLegacy && pack.capsules_per_pack !== pack.units_per_pack) return null;

      var unitPlural = hasGeneric ? packSummaryWord(pack.unit_label_plural) : HH_LEGACY_UNIT_PLURAL;
      if (!unitPlural) return null;

      var statesPackSingular = isStatedPackField(pack.pack_label_singular);
      var statesPackPlural = isStatedPackField(pack.pack_label_plural);
      var packSingular = packSummaryWord(pack.pack_label_singular);
      var packPlural = packSummaryWord(pack.pack_label_plural);
      if (!statesPackSingular && !statesPackPlural) {
        // Both entirely unstated: the legacy capsule contract keeps the
        // container wording it already prints; the generic contract has
        // nothing to default to.
        if (hasGeneric) return null;
        packSingular = HH_LEGACY_PACK_SINGULAR;
        packPlural = HH_LEGACY_PACK_PLURAL;
      } else if (!packSingular || !packPlural) {
        // Half-stated pair, or a stated container word that is empty or not a
        // string: the missing/malformed form is never derived from the other
        // one and never falls back to the legacy bottle words.
        return null;
      }
      return {
        per_pack: perPack,
        unit_plural: unitPlural,
        pack_singular: packSingular,
        pack_plural: packPlural
      };
    }

    // Shows the concise pack summary (N packs · units total · labelled
    // servings · rounded rupee price per labelled serving) directly above
    // the CTA, using the exact same totalCents the CTA label shows. Only
    // renders for a variant whose own approved pack carries an explicit,
    // positive-integer unit count with the exact words to print it (see
    // resolvePackSummaryUnits) plus an explicit, positive-integer
    // servings_per_pack — this never infers or guesses a count, a unit word
    // or a container word for a pack that hasn't stated them.
    function updateOfferSummary(variant, offer, totalCents) {
      if (!offerSummaryEl) return;
      var pack = variant ? getApprovedPack(variant.id) : null;
      var units = resolvePackSummaryUnits(pack);
      var hasPackCounts = !!units && isSafePositiveInteger(pack.servings_per_pack);
      if (!variant || !variant.available || !offer || totalCents == null || !hasPackCounts) {
        offerSummaryEl.hidden = true;
        offerSummaryEl.textContent = '';
        return;
      }
      var packCount = offer.quantity;
      var totalUnits = packCount * units.per_pack;
      var totalServings = packCount * pack.servings_per_pack;
      // The approved PDP presents a whole-rupee comparison (for example ₹9),
      // while Shopify's money format can append decimals even to whole rupees.
      var perServingRupees = Math.round(totalCents / totalServings / 100);
      var perServingText = '₹' + new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 }).format(perServingRupees);
      var packWord = packCount === 1 ? units.pack_singular : units.pack_plural;
      offerSummaryEl.textContent =
        packCount + ' ' + packWord + ' · ' + totalUnits + ' ' + units.unit_plural + ' total · ' +
        totalServings + ' labelled servings · ' + perServingText + ' per labelled serving';
      offerSummaryEl.hidden = false;
    }

    function updateSavings(variant, offer, totalCents) {
      if (!savingsEl) return;
      var amountText = null;
      var hasTemplate = savingsTemplate.indexOf('[amount]') !== -1 && savingsTemplate.indexOf('[percent]') !== -1;
      var hasOffer = hasTemplate && variant && variant.available && offer &&
        Number.isFinite(totalCents) && Number.isSafeInteger(offer.quantity) && offer.quantity >= 2 &&
        Number.isFinite(offer.percent) && offer.percent > 0 && Number.isFinite(variant.price);
      if (hasOffer) {
        var savingsCents = variant.price * offer.quantity - totalCents;
        if (Number.isFinite(savingsCents) && savingsCents > 0) {
          if (isInrDisplay) {
            if (Math.round(savingsCents / 100) > 0) amountText = inrWholeRupees(savingsCents);
          } else {
            amountText = fallbackMoney(savingsCents);
          }
        }
      }
      if (!amountText) {
        savingsEl.hidden = true;
        if (savingsEl.textContent) savingsEl.textContent = '';
        return;
      }
      savingsEl.hidden = false;
      var savingsText = savingsTemplate.replace('[amount]', amountText).replace('[percent]', formatPercent(offer.percent));
      if (savingsEl.textContent !== savingsText) savingsEl.textContent = savingsText;
    }

    // Compact Qty select, opted into per product by [data-hh-pdp-qty-compact]
    // in sections/hh-pdp.liquid, which now resolves that attribute from the
    // shared section.settings.compact_quantity boolean (default true) rather
    // than a product-id allowlist. It mirrors the recognized, current-variant
    // Appstle offers that are already live in the widget (today Buy 1/2/4)
    // and nothing else — it never adds a discount tier, and it never derives
    // a price, percent or quantity from its own value. Changing it only ever
    // asks the app, by clicking the original matching radio; the resulting
    // CTA/summary/savings/quantity repaint all comes from the validated
    // checked radio via refreshOfferDisplay(). The native [name=quantity]
    // number input stays the one submitted field: while this control is
    // active that input is hidden and untabbable (never disabled, so the
    // no-JS native form fallback still posts a quantity), so exactly one
    // interactive quantity control exists at a time.
    var compactQtyEnabled = root.getAttribute('data-hh-pdp-qty-compact') === 'true';
    var compactQtyWrap = null;
    var compactQtySelect = null;
    var compactQtySignature = null;
    // Editing guard: true from a trusted click/keydown on the compact select
    // until the user's explicit change (commit) or blur (cancel). While it is
    // true, compactQtyPending holds the value the open native menu is carrying
    // and refreshes must not overwrite it.
    var compactQtyEditing = false;
    var compactQtyPending = null;
    // Delegated on the PDP root at init so the guard is already listening
    // before buildCompactQty() ever creates the select, and so it survives the
    // option-list rebuilds. click/keydown/change are all accepted without an
    // isTrusted requirement, but only when the target is this very select:
    // a native/assistive menu opened through the accessibility layer (AX
    // Press, OS popup arrow navigation) need not surface a trusted DOM
    // event, and a change on this select always means a settled user choice.
    // Nothing outside this control can arm the guard, and the guard only
    // ever preserves a value the user is already carrying - it never
    // authorizes a quantity or price of its own.
    if (compactQtyEnabled) {
      listen(root, 'change', onCompactQtyRootChange, true);
      listen(root, 'click', onCompactQtyRootIntent, true);
      listen(root, 'keydown', onCompactQtyRootIntent, true);
    }
    // Reuses the native row's own label copy, so this introduces no new
    // (untranslated) string of its own.
    var compactQtyLabelText = (function () {
      var nativeLabel = qtyRow ? qtyRow.querySelector('.hh-pdp__qty-label') : null;
      var text = nativeLabel ? nativeLabel.textContent.trim() : '';
      return text || 'Qty';
    })();

    function buildCompactQty() {
      if (compactQtySelect || !cartForm || !atcButton) return;
      compactQtyWrap = document.createElement('div');
      compactQtyWrap.className = 'hh-pdp__qty-compact';
      compactQtyWrap.setAttribute('data-hh-pdp-qty-compact-row', '');
      var label = document.createElement('label');
      label.className = 'hh-pdp__qty-compact-label';
      label.setAttribute('for', 'hh-pdp-qty-compact-' + sectionId);
      label.textContent = compactQtyLabelText;
      compactQtySelect = document.createElement('select');
      compactQtySelect.className = 'hh-pdp__qty-compact-select';
      compactQtySelect.id = 'hh-pdp-qty-compact-' + sectionId;
      // Deliberately nameless: the native number input remains the only
      // quantity field this form submits.
      compactQtySelect.setAttribute('data-hh-pdp-qty-compact-select', '');
      listen(compactQtySelect, 'change', onCompactQtyChange);
      // Safari's accessibility path can open the native menu with focus only,
      // producing neither a DOM click nor a keydown. Focus is therefore enough
      // to arm the pending edit; refreshOfferDisplay()'s state sync only ever
      // assigns .value and never focuses or dispatches events, so a repaint
      // cannot arm the guard by itself.
      listen(compactQtySelect, 'focus', onCompactQtyFocus);
      // Leaving the control without committing cancels the pending edit and
      // resyncs from the validated widget state.
      listen(compactQtySelect, 'blur', onCompactQtyBlur);
      compactQtyWrap.appendChild(label);
      compactQtyWrap.appendChild(compactQtySelect);
      // Inserted between the offer summary and the CTA, so the order stays
      // offer widget -> summary -> Qty -> Add to cart and relocateOfferWidget's
      // target ([data-hh-pdp-qty-row]) is left exactly where it already is.
      cartForm.insertBefore(compactQtyWrap, atcButton);
    }

    function isCompactQtyTarget(target) {
      if (!compactQtySelect || !target) return false;
      if (target === compactQtySelect) return true;
      return typeof target.closest === 'function' &&
        target.closest('[data-hh-pdp-qty-compact-select]') === compactQtySelect;
    }

    function beginCompactQtyEdit() {
      if (!compactQtySelect || !compactQtyWrap || compactQtyWrap.hidden) return;
      compactQtyEditing = true;
      compactQtyPending = compactQtySelect.value;
    }

    function endCompactQtyEdit() {
      compactQtyEditing = false;
      compactQtyPending = null;
    }

    function onCompactQtyFocus() {
      beginCompactQtyEdit();
    }

    function onCompactQtyRootIntent(event) {
      if (!event) return;
      // Scoped to this select only - an untrusted event anywhere else in the
      // PDP still cannot arm the guard.
      if (!isCompactQtyTarget(event.target)) return;
      // Re-arms on every new menu open / keyboard interaction, including when
      // the select never lost focus after the previous commit.
      beginCompactQtyEdit();
    }

    function onCompactQtyRootChange(event) {
      if (!event || !isCompactQtyTarget(event.target)) return;
      endCompactQtyEdit();
    }

    function onCompactQtyBlur() {
      if (!compactQtyEditing) return;
      endCompactQtyEdit();
      refreshOfferDisplay();
    }

    function onCompactQtyChange() {
      // Explicit user choice: release the guard first, so the repaint below
      // and any later app-driven refresh show the app's committed state.
      endCompactQtyEdit();
      var variant = findVariant(selectedVariantId);
      var requested = Number(compactQtySelect.value);
      var offers = variant ? listAppstleOffers(root, variant.id) : [];
      var target = null;
      for (var i = 0; i < offers.length; i++) {
        if (offers[i].quantity === requested) target = offers[i];
      }
      // Nothing recognized to ask the app for (replaced/stale/malformed
      // widget): resync from the validated widget state instead of acting on
      // this control's own value.
      if (target) {
        if (target.radio.getAttribute('aria-checked') !== 'true') target.radio.click();
      }
      // The app may only answer later (its own promise/re-render). Repaint
      // from the still-authoritative checked radio right now, so the select
      // can never show 4 while the submitted quantity is 1; the widget
      // observer synchronizes again once the app has actually switched.
      refreshOfferDisplay();
    }

    function setCompactQtyActive(active) {
      if (compactQtyWrap) compactQtyWrap.hidden = !active;
      if (!qtyInput) return;
      if (active) {
        qtyInput.hidden = true;
        qtyInput.tabIndex = -1;
      } else {
        qtyInput.hidden = false;
        qtyInput.removeAttribute('tabindex');
      }
    }

    function updateCompactQty(variant, offer) {
      if (!compactQtyEnabled) return;
      var offers = variant && variant.available && offer ? listAppstleOffers(root, variant.id) : [];
      // No current offer, a sold-out variant, or fewer than two recognized
      // tiers to choose between: fall back to the existing behaviour for that
      // state untouched (the native number input when no offer is selected).
      if (!offer || offers.length < 2) {
        compactQtySignature = null;
        // Stale/replaced widget or sold-out variant: the control is going away,
        // so no pending edit may survive into the native fallback.
        endCompactQtyEdit();
        setCompactQtyActive(false);
        return;
      }
      buildCompactQty();
      if (!compactQtySelect) return;
      // Track what the open menu currently carries, so it can be restored
      // after an option-list rebuild as well.
      if (compactQtyEditing) compactQtyPending = compactQtySelect.value;
      var signature = offers.map(function (entry) { return entry.quantity; }).join(',');
      // Only ever touch the option list when the list itself changed. The
      // root-level MutationObserver re-runs attachCurrentWidget on every
      // childList change in this subtree (including these), so rebuilding
      // unconditionally would re-enter this function forever; everything
      // else below is property-only and unobserved.
      if (signature !== compactQtySignature) {
        compactQtySignature = signature;
        compactQtySelect.textContent = '';
        offers.forEach(function (entry) {
          var option = document.createElement('option');
          option.value = String(entry.quantity);
          option.textContent = String(entry.quantity);
          compactQtySelect.appendChild(option);
        });
      }
      var value = String(offer.quantity);
      if (compactQtyEditing) {
        // Mid-edit: unrelated childList mutations in this subtree must not
        // overwrite the value Safari is holding for the open native menu,
        // otherwise the pending choice is lost before change can fire.
        if (compactQtyPending !== null && compactQtySelect.value !== compactQtyPending) {
          compactQtySelect.value = compactQtyPending;
        }
      } else if (compactQtySelect.value !== value) {
        compactQtySelect.value = value;
      }
      setCompactQtyActive(true);
    }

    function refreshOfferDisplay() {
      var variant = findVariant(selectedVariantId);
      if (!variant) {
        if (offerSummaryEl) {
          offerSummaryEl.hidden = true;
          offerSummaryEl.textContent = '';
        }
        updateSavings(null, null, null);
        updateCompactQty(null, null);
        return;
      }
      if (isInrDisplay) updateAppstleExactMoney(root, variant);
      var offer = getSelectedAppstleOffer(root, variant.id);
      if (offer) {
        var totalCents = computeOfferTotalCents(variant, offer);
        if (atcLabel && totalCents != null) {
          var label = variant.available ? 'Add to cart · ' + ctaMoney(totalCents) : 'Sold out';
          if (atcLabel.textContent !== label) atcLabel.textContent = label;
        }
        if (qtyRow) qtyRow.hidden = true;
        // Appstle's offer widget lives outside this native form (it is
        // not wrapped in a Shopify product form here), so it never updates
        // this form's own quantity field. Without this, the form always
        // submits quantity 1 to /cart/add regardless of the Buy 2/4 offer
        // shown in the CTA. We only ever set the actual submitted quantity
        // here; we do not fabricate a discount or assume checkout applies one.
        if (qtyInput && qtyInput.value !== String(offer.quantity)) {
          qtyInput.value = String(offer.quantity);
        }
        updateOfferSummary(variant, offer, totalCents);
        updateSavings(variant, offer, totalCents);
        // Last, so the compact control's options/value are rebuilt from the
        // same validated offer that just set the submitted quantity, the CTA
        // and the summary — the four can never disagree.
        updateCompactQty(variant, offer);
      } else {
        updateAtc(variant);
        if (qtyRow) qtyRow.hidden = false;
        if (qtyInput && qtyInput.value !== manualQty) qtyInput.value = manualQty;
        updateOfferSummary(variant, null, null);
        updateSavings(null, null, null);
        updateCompactQty(variant, null);
      }
    }

    function updatePills(variantId) {
      pills.forEach(function (pill) {
        var isActive = String(pill.getAttribute('data-variant-id')) === String(variantId);
        pill.classList.toggle('is-active', isActive);
        pill.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });
    }

    function updateGallery(variantId) {
      // galleryMap is server-built with one entry per variant (pack.gallery when
      // approved, otherwise that exact variant's own featured_media/placeholder),
      // so every known variant id resolves to media that belongs to it.
      // Fail closed rather than fail open: an absent or empty entry must
      // still REPLACE whatever the previous pack rendered, with the neutral
      // placeholder, instead of returning early and leaving that pack's
      // media on screen. The Liquid map never emits an empty array, so this
      // is defense in depth against a malformed data island.
      var items = galleryMap[String(variantId)];
      if (!Array.isArray(items) || items.length === 0) {
        items = [{ type: 'placeholder', alt: root.getAttribute('data-product-title') || '' }];
      }
      galleryItemsRef.items = items;
      renderGallery(galleryMain, galleryThumbs, galleryTeaser, items, root, galleryCaption, galleryPrevBtn, galleryNextBtn);
    }

    function safeContentUrl(url) {
      return typeof url === 'string' && /^(https:\/\/|\/(?!\/))/.test(url) ? url : '';
    }

    function updatePurchaseComparison(pack, variantId) {
      if (!purchaseComparisonEl) return;
      while (purchaseComparisonEl.firstChild) purchaseComparisonEl.removeChild(purchaseComparisonEl.firstChild);
      if (typedPresence[String(variantId)] === true) {
        var item = pack && pack.approved === true && pack.purchase_comparison;
        var url = item && safeContentUrl(item.url);
        if (item && typeof item.label === 'string' && item.label.trim() && url && url.indexOf('\\') === -1) {
          var link = document.createElement('a');
          link.className = 'hh-pdp__quick-link hh-pdp__formula-cta';
          link.href = url;
          link.textContent = item.label;
          purchaseComparisonEl.appendChild(link);
        }
      } else if (purchaseComparisonDefaults && purchaseComparisonDefaults.content) {
        purchaseComparisonEl.appendChild(purchaseComparisonDefaults.content.cloneNode(true));
      }
      purchaseComparisonEl.hidden = !purchaseComparisonEl.querySelector('a');
    }

    function updateReassurance(pack, variantId) {
      if (!reassuranceEl) return;
      while (reassuranceEl.firstChild) reassuranceEl.removeChild(reassuranceEl.firstChild);
      if (typedPresence[String(variantId)] === true) {
        var links = pack && pack.approved === true && Array.isArray(pack.reassurance_links) ? pack.reassurance_links : [];
        // More than the schema maximum is malformed, not permission to trim.
        if (links.length <= 3) links.forEach(function (item) {
          var url = item && safeContentUrl(item.url);
          if (!item || !item.label || !url || url.indexOf('\\') !== -1) return;
          var li = document.createElement('li');
          var link = document.createElement('a');
          link.href = url;
          link.textContent = item.label;
          li.appendChild(link);
          reassuranceEl.appendChild(li);
        });
      } else if (reassuranceDefaults && reassuranceDefaults.content) {
        // These defaults were escaped and URL-checked by Liquid. Native
        // absence alone permits them; blank/disabled native content does not.
        reassuranceEl.appendChild(reassuranceDefaults.content.cloneNode(true));
      }
      reassuranceEl.hidden = !reassuranceEl.querySelector('li');
    }

    function buildContentLinks(links, linkClass) {
      if (!Array.isArray(links)) return null;
      var validLinks = links.filter(function (link) { return link && link.label && safeContentUrl(link.url); });
      if (!validLinks.length) return null;
      var list = document.createElement('ul');
      list.className = 'hh-pdp__content-links';
      list.setAttribute('role', 'list');
      validLinks.forEach(function (item) {
        var li = document.createElement('li');
        var link = document.createElement('a');
        link.className = linkClass || '';
        link.href = safeContentUrl(item.url);
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = item.label;
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = ' ↗';
        link.appendChild(arrow);
        li.appendChild(link);
        [['note','hh-pdp__content-link-note'],['evidence_kind','hh-pdp__content-link-kind'],['sample_scope','hh-pdp__content-link-scope']].forEach(function (entry) {
          if (!item[entry[0]]) return;
          var p = document.createElement('p');
          p.className = entry[1];
          p.textContent = item[entry[0]];
          li.appendChild(p);
        });
        list.appendChild(li);
      });
      return list;
    }

    function appendStoryExtras(target, card, showImage, showItems) {
      if (!card) return;
      if (Array.isArray(card.bullets) && card.bullets.length) {
        var bullets = document.createElement('ul');
        bullets.className = 'hh-pdp__story-bullets';
        bullets.setAttribute('role', 'list');
        card.bullets.forEach(function (bullet) {
          if (typeof bullet !== 'string' || !bullet) return;
          var li = document.createElement('li');
          li.textContent = bullet;
          bullets.appendChild(li);
        });
        target.appendChild(bullets);
      }
      if (showItems && Array.isArray(card.items) && card.items.length) {
        var facts = document.createElement('dl');
        facts.className = 'hh-pdp__story-serving-facts';
        card.items.forEach(function (item) {
          if (!item || !item.label || !item.value) return;
          var row = document.createElement('div');
          var dt = document.createElement('dt');
          dt.textContent = item.label;
          var dd = document.createElement('dd');
          dd.textContent = item.value;
          row.appendChild(dt);
          row.appendChild(dd);
          facts.appendChild(row);
        });
        target.appendChild(facts);
      }
      var links = buildContentLinks(card.links, 'hh-pdp__story-text-link');
      if (links) target.appendChild(links);
      if (card.link_label && safeContentUrl(card.link_url)) {
        var link = document.createElement('a');
        link.className = 'hh-pdp__story-text-link';
        link.href = safeContentUrl(card.link_url);
        link.textContent = card.link_label;
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = ' ↗';
        link.appendChild(arrow);
        target.appendChild(link);
      }
      if (showImage && safeContentUrl(card.image)) {
        var figure = document.createElement('figure');
        figure.className = 'hh-pdp__story-extra-media';
        figure.setAttribute('data-image-role', card.image_role || '');
        var image = document.createElement('img');
        image.src = safeContentUrl(card.image);
        image.alt = card.image_alt || '';
        image.loading = 'lazy';
        image.width = 600;
        image.height = 600;
        figure.appendChild(image);
        target.appendChild(figure);
      }
    }

    function buildStoryBenefitsSection(pack, productTitle) {
      var benefits = pack && pack.story && pack.story.benefits;
      if (!benefits || !benefits.lead) return null;
      var items = Array.isArray(benefits.items)
        ? benefits.items.filter(function (item) { return item && item.heading; })
        : [];


      var section = document.createElement('section');
      section.className = 'hh-pdp__story-section hh-pdp__story-section--benefits';
      var eyebrow = document.createElement('p');
      eyebrow.className = 'hh-pdp__story-eyebrow';
      var eyebrowMark = document.createElement('span');
      eyebrowMark.setAttribute('aria-hidden', 'true');
      eyebrowMark.textContent = '01 /';
      eyebrow.appendChild(eyebrowMark);
      eyebrow.appendChild(document.createTextNode(' Benefits'));
      if (benefits.eyebrow) eyebrow.textContent = benefits.eyebrow;
      var grid = document.createElement('div');
      grid.className = 'hh-pdp__story-benefits-grid';

      var copy = document.createElement('div');
      copy.className = 'hh-pdp__story-benefits-copy';
      copy.appendChild(eyebrow);
      var heading = document.createElement('h2');
      heading.className = 'hh-pdp__story-heading';
      heading.id = 'hh-pdp-story-benefits-' + sectionId;
      heading.textContent = benefits.heading || 'What this pack supports';
      copy.appendChild(heading);
      var lead = document.createElement('p');
      lead.className = 'hh-pdp__story-lead';
      lead.textContent = benefits.lead;
      copy.appendChild(lead);
      appendStoryExtras(copy, benefits, false, false);
      var choosePack = document.createElement('a');
      choosePack.className = 'hh-pdp__story-action';
      var defaultPicker = select && select.closest('[data-hh-pdp-variant-picker][aria-hidden="true"]');
      choosePack.href = defaultPicker && select.form ? '#' + select.form.getAttribute('id') : '#hh-pdp-variant-select-' + sectionId;
      choosePack.textContent = 'Choose your pack ';
      var chooseArrow = document.createElement('span');
      chooseArrow.setAttribute('aria-hidden', 'true');
      chooseArrow.textContent = '↗';
      choosePack.appendChild(chooseArrow);
      copy.appendChild(choosePack);
      grid.appendChild(copy);

      var imageUrl = safeMediaUrl(benefits.image);
      if (imageUrl) {
        var figure = document.createElement('figure');
        figure.className = 'hh-pdp__story-media';
        figure.setAttribute('data-image-role', benefits.image_role || '');
        var img = document.createElement('img');
        img.src = imageUrl;
        img.alt = benefits.image_alt || productTitle || '';
        img.loading = 'lazy';
        img.width = 600;
        img.height = 600;
        figure.appendChild(img);
        grid.appendChild(figure);
      }
      section.appendChild(grid);

      var list = document.createElement('ul');
      list.className = 'hh-pdp__story-benefit-list';
      list.setAttribute('role', 'list');
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.innerHTML = iconSvg(item.icon);
        var textWrap = document.createElement('div');
        var labelEl = document.createElement('span');
        labelEl.textContent = item.label || 'Supports';
        textWrap.appendChild(labelEl);
        var h3 = document.createElement('h3');
        h3.textContent = item.heading;
        textWrap.appendChild(h3);
        li.appendChild(textWrap);
        list.appendChild(li);
      });
      if (items.length) section.appendChild(list);
      section.setAttribute('aria-labelledby', heading.id);
      return section;
    }

    // Mirrors the capsule-motion panel sections/hh-pdp.liquid renders into
    // [data-hh-pdp-capsule-slot] (via the separate hh-pdp-capsule.liquid
    // snippet): gated only by this exact pack's own
    // pack.story.capsule_motion === true, never inherited by any
    // other pack/variant. Builds the same markup hh-pdp-universal-capsule.js expects
    // (a <hh-pdp-capsule-motion> custom element wrapping the video/button),
    // and lazily loads that script exactly once.
    var capsuleScriptLoaded = false;
    function loadCapsuleScript() {
      if (customElements.get('hh-pdp-capsule-motion')) return;
      if (capsuleScriptLoaded) return;
      capsuleScriptLoaded = true;
      var existing = document.querySelector('script[data-hh-pdp-capsule-script]');
      if (existing) return;
      var script = document.createElement('script');
      script.src = root.getAttribute('data-hh-pdp-capsule-script-url') || '';
      script.defer = true;
      script.setAttribute('data-hh-pdp-capsule-script', '');
      if (script.src) document.body.appendChild(script);
    }

    function buildCapsuleMotionSection(pack) {
      var enabled = pack && pack.story && pack.story.capsule_motion === true;
      if (!enabled || !capsuleMedia) return null;
      var labels = capsuleMedia.labels || {};

      var section = document.createElement('section');
      section.className = 'hh-pdp__capsule-panel';
      var headingWrap = document.createElement('div');
      headingWrap.className = 'hh-pdp__capsule-heading';
      var heading = document.createElement('h2');
      heading.className = 'hh-pdp__story-heading';
      heading.id = 'hh-pdp-capsule-title-' + sectionId;
      heading.textContent = labels.heading || 'A closer look inside';
      headingWrap.appendChild(heading);
      if (pack.label && ((Array.isArray(pack.label.ingredients) && pack.label.ingredients.length) || safeMediaUrl(pack.label.image_url))) {
        var ingredientLink = document.createElement('a');
        ingredientLink.className = 'hh-pdp__story-text-link';
        ingredientLink.href = '#hh-pdp-ingredients-' + sectionId;
        ingredientLink.setAttribute('data-hh-pdp-story-disclosure', '');
        ingredientLink.textContent = 'View ingredients & label ';
        var ingredientArrow = document.createElement('span');
        ingredientArrow.setAttribute('aria-hidden', 'true');
        ingredientArrow.textContent = '↗';
        ingredientLink.appendChild(ingredientArrow);
        headingWrap.appendChild(ingredientLink);
      }
      section.appendChild(headingWrap);
      section.setAttribute('aria-labelledby', heading.id);

      var figure = document.createElement('figure');
      figure.className = 'hh-pdp__capsule-figure';
      var motionEl = document.createElement('hh-pdp-capsule-motion');
      var video = document.createElement('video');
      video.width = 640;
      video.height = 360;
      video.muted = true;
      video.playsInline = true;
      video.loop = capsuleMedia.loop !== false;
      video.dataset.loop = String(capsuleMedia.loop !== false);
      video.preload = 'none';
      video.controls = true;
      video.poster = capsuleMedia.poster;
      video.dataset.src = capsuleMedia.src;
      video.setAttribute('aria-label', labels.aria_label || 'Generic illustration of a vegetable capsule opening. Not a depiction of this specific pack.');
      var captionId = 'hh-pdp-capsule-caption-' + sectionId;
      video.setAttribute('aria-describedby', captionId);
      motionEl.appendChild(video);
      var button = document.createElement('button');
      button.type = 'button';
      button.hidden = true;
      button.dataset.state = 'play';
      button.setAttribute('aria-label', labels.play || 'Play capsule animation');
      button.dataset.play = labels.play || 'Play capsule animation';
      button.dataset.pause = labels.pause || 'Pause capsule animation';
      button.dataset.replay = labels.replay || 'Replay capsule animation';
      button.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false"><path class="hh-pdp__capsule-play-icon" d="m9 5 11 7-11 7Z"/><g class="hh-pdp__capsule-pause-icon"><path d="M8 5v14M16 5v14"/></g></svg>';
      motionEl.appendChild(button);
      figure.appendChild(motionEl);
      var caption = document.createElement('figcaption');
      caption.id = captionId;
      caption.className = 'hh-pdp__story-fine';
      caption.textContent = labels.caption || "Generic illustration of a vegetable capsule opening — not a depiction of this specific pack's contents or dose.";
      figure.appendChild(caption);
      section.appendChild(figure);

      loadCapsuleScript();
      return section;
    }

    // Strict JS-side mirror of the Liquid capsule-count gate: must be a real
    // JSON integer (never a numeric string — "no parseInt strings") in 1..6.
    function isValidCapsuleCount(value) {
      return typeof value === 'number' && Number.isInteger(value) && value >= 1 && value <= 6;
    }
    var HH_CAPSULE_COLOURS = ['white', 'green', 'transparent', 'amber'];

    // Strict JS-side mirror of the Liquid serving_form gate in
    // snippets/hh-pdp-story.liquid. An explicit form must be exactly one of
    // 'capsule' | 'softgel' | 'none' (identity comparisons, so a number or
    // boolean can never pass); anything else fails closed — the serving text
    // still renders, but no artwork and no numbered statement are drawn. A
    // missing/empty form keeps the legacy two-piece capsule artwork for
    // packs authored before this field, and the form is NEVER inferred from
    // serving_size or capsule_unit_label text.
    function resolveServingForm(value) {
      if (value === undefined || value === null || value === '') {
        return { supported: true, draws: true, name: 'capsule' };
      }
      if (value === 'capsule' || value === 'softgel') {
        return { supported: true, draws: true, name: value };
      }
      if (value === 'none') return { supported: true, draws: false, name: 'none' };
      return { supported: false, draws: false, name: '' };
    }

    // Mirrors the Serving section of hh-pdp-story.liquid: all copy comes
    // from this exact pack's own story.serving fields (eyebrow/heading/lead/
    // labels) — never generic or product-specific placeholder text. The
    // capsule pill motif and the numbered "N <unit> per serving" statement
    // are a separate, optional opt-in: a missing/invalid capsules_per_serving
    // or capsule_colour never defaults to one white capsule and is never
    // inferred by parsing serving_size text.
    function buildStoryServingSection(pack) {
      var serving = pack && pack.story && pack.story.serving;
      if (!serving) return null;
      var hasServingSize = !!(serving.serving_size_label && serving.serving_size);
      var hasFormulation = !!(serving.formulation_label && serving.ingredient_amount && serving.ingredient_label);
      var extraFacts = Array.isArray(serving.facts) ? serving.facts.filter(function (fact) {
        return fact && fact.label && fact.value;
      }) : [];
      if (!serving.heading || !serving.lead || (!hasServingSize && !extraFacts.length)) return null;
      var showServingAmount = !!(pack.elemental_amount && pack.elemental_label && serving.per_serving_caption);

      var servingForm = resolveServingForm(serving.serving_form);
      var capsuleCountValid = isValidCapsuleCount(serving.capsules_per_serving);
      var capsuleUnitLabel = capsuleCountValid && serving.capsules_per_serving === 1 && serving.unit_singular
        ? serving.unit_singular : serving.capsule_unit_label;
      var showCapsuleCountText = capsuleCountValid && !!capsuleUnitLabel && servingForm.supported && !!serving.per_serving_caption;
      var capsuleColourValid = capsuleCountValid && servingForm.draws && !!serving.per_serving_caption &&
        HH_CAPSULE_COLOURS.indexOf(serving.capsule_colour) !== -1;

      var section = document.createElement('section');
      section.className = 'hh-pdp__story-section hh-pdp__story-section--serving';
      var eyebrow = document.createElement('p');
      eyebrow.className = 'hh-pdp__story-eyebrow';
      eyebrow.textContent = serving.eyebrow;
      var grid = document.createElement('div');
      grid.className = 'hh-pdp__story-serving-grid';

      var copy = document.createElement('div');
      copy.className = 'hh-pdp__story-serving-copy';
      if (serving.eyebrow) copy.appendChild(eyebrow);
      var heading = document.createElement('h2');
      heading.className = 'hh-pdp__story-heading';
      heading.id = 'hh-pdp-story-serving-' + sectionId;
      heading.textContent = serving.heading;
      copy.appendChild(heading);
      var lead = document.createElement('p');
      lead.className = 'hh-pdp__story-lead';
      lead.textContent = serving.lead;
      copy.appendChild(lead);
      var hasLabelIngredients = pack.label && ((Array.isArray(pack.label.ingredients) && pack.label.ingredients.length > 0) || safeMediaUrl(pack.label.image_url));
      var servingLinkUrl = serving.link_url ? (typeof serving.link_url === 'string' && /^(https:\/\/|\/(?!\/))/.test(serving.link_url) ? serving.link_url : '')
        : (hasLabelIngredients ? '#hh-pdp-ingredients-' + sectionId : '');
      if (servingLinkUrl && serving.label_link_text) {
        var labelLink = document.createElement('a');
        labelLink.className = 'hh-pdp__story-text-link';
        labelLink.href = servingLinkUrl;
        if (!serving.link_url) labelLink.setAttribute('data-hh-pdp-story-disclosure', '');
        labelLink.textContent = serving.label_link_text + ' ';
        var labelArrow = document.createElement('span');
        labelArrow.setAttribute('aria-hidden', 'true');
        labelArrow.textContent = '↗';
        labelLink.appendChild(labelArrow);
        copy.appendChild(labelLink);
      }
      grid.appendChild(copy);

      var visual = document.createElement('div');
      visual.className = 'hh-pdp__story-serving-visual';
      var showCapsuleBlock = showCapsuleCountText || capsuleColourValid;
      var graphic = document.createElement('div');
      graphic.className = 'hh-pdp__story-serving-graphic';

      if (showCapsuleCountText) {
        var count = document.createElement('div');
        count.className = 'hh-pdp__story-serving-count';
        var servingNumber = document.createElement('strong');
        servingNumber.textContent = String(serving.capsules_per_serving);
        count.appendChild(servingNumber);
        var servingUnit = document.createElement('span');
        servingUnit.textContent = capsuleUnitLabel;
        servingUnit.appendChild(document.createElement('br'));
        servingUnit.appendChild(document.createTextNode(serving.per_serving_caption));
        count.appendChild(servingUnit);
        graphic.appendChild(count);
      }

      if (capsuleColourValid) {
        var pillGroup = document.createElement('div');
        pillGroup.className = 'hh-pdp__story-capsule hh-pdp__story-capsule-group--' + serving.capsules_per_serving;
        pillGroup.setAttribute('aria-hidden', 'true');
        for (var i = 0; i < serving.capsules_per_serving; i++) {
          var pill = document.createElement('span');
          pill.className = 'hh-pdp__story-capsule-pill hh-pdp__story-capsule-pill--' +
            serving.capsule_colour + ' hh-pdp__story-capsule-pill--' + servingForm.name;
          pillGroup.appendChild(pill);
        }
        graphic.appendChild(pillGroup);
      }
      if (showCapsuleBlock) visual.appendChild(graphic);

      if (showServingAmount) {
        var dose = document.createElement('div');
        dose.className = 'hh-pdp__story-dose';
        var doseNumber = document.createElement('span');
        doseNumber.className = 'hh-pdp__story-dose-number';
        doseNumber.textContent = pack.elemental_amount;
        dose.appendChild(doseNumber);
        var doseLabel = document.createElement('span');
        doseLabel.className = 'hh-pdp__story-dose-label';
        doseLabel.textContent = pack.elemental_label || '';
        dose.appendChild(doseLabel);
        visual.appendChild(dose);
      }

      var facts = document.createElement('dl');
      facts.className = 'hh-pdp__story-serving-facts';
      var servingFacts = [];
      if (hasServingSize) servingFacts.push([serving.serving_size_label, serving.serving_size]);
      if (hasFormulation) servingFacts.push([serving.formulation_label, serving.ingredient_amount + ' ' + serving.ingredient_label]);
      extraFacts.forEach(function (fact) { servingFacts.push([fact.label, fact.value]); });
      servingFacts.forEach(function (entry) {
        var row = document.createElement('div');
        var dt = document.createElement('dt');
        dt.textContent = entry[0];
        row.appendChild(dt);
        var dd = document.createElement('dd');
        dd.textContent = entry[1];
        row.appendChild(dd);
        facts.appendChild(row);
      });
      visual.appendChild(facts);

      if (serving.note) {
        var fine = document.createElement('p');
        fine.className = 'hh-pdp__story-fine';
        fine.textContent = serving.note;
        visual.appendChild(fine);
      }

      grid.appendChild(visual);
      section.appendChild(grid);
      section.setAttribute('aria-labelledby', heading.id);
      return section;
    }

    function buildStoryQualitySection(pack) {
      var quality = pack && pack.quality;
      var card = pack && pack.story && pack.story.quality;
      var qualityTitle = card ? card.heading : quality && quality.title;
      var qualityBody = card ? card.lead : quality && quality.body;
      if (!quality || quality.approved !== true || !qualityTitle || !qualityBody) return null;

      var section = document.createElement('section');
      section.className = 'hh-pdp__story-section hh-pdp__story-section--quality';
      var eyebrow = document.createElement('p');
      eyebrow.className = 'hh-pdp__story-eyebrow';
      var eyebrowMark = document.createElement('span');
      eyebrowMark.setAttribute('aria-hidden', 'true');
      eyebrowMark.textContent = '03 /';
      eyebrow.appendChild(eyebrowMark);
      eyebrow.appendChild(document.createTextNode(' Quality'));
      if (card && card.eyebrow) eyebrow.textContent = card.eyebrow;
      var grid = document.createElement('div');
      grid.className = 'hh-pdp__story-quality-grid';

      var copy = document.createElement('div');
      copy.className = 'hh-pdp__story-quality-copy';
      copy.appendChild(eyebrow);
      var heading = document.createElement('h2');
      heading.className = 'hh-pdp__story-heading';
      heading.id = 'hh-pdp-story-quality-' + sectionId;
      heading.textContent = qualityTitle;
      copy.appendChild(heading);
      var lead = document.createElement('p');
      lead.className = 'hh-pdp__story-lead';
      lead.textContent = qualityBody;
      copy.appendChild(lead);
      if (quality.note) {
        var fine = document.createElement('p');
        fine.className = 'hh-pdp__story-fine';
        fine.textContent = quality.note;
        copy.appendChild(fine);
      }
      var linkUrl = quality.link ? safeMediaUrl(quality.link.url) : '';
      if (Array.isArray(quality.links) && quality.links.length) {
        var qualityLinks = buildContentLinks(quality.links, 'hh-pdp__story-link');
        if (qualityLinks) copy.appendChild(qualityLinks);
      } else if (linkUrl && quality.link.label) {
        var link = document.createElement('a');
        link.className = 'hh-pdp__story-link';
        link.href = linkUrl;
        link.textContent = quality.link.label;
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = ' →';
        link.appendChild(arrow);
        copy.appendChild(link);
      }
      appendStoryExtras(copy, card, true, true);
      grid.appendChild(copy);

      // Mirrors the "Manufactured & certified by" credential cards:
      // optional, reuses pack.quality's own approval gate; never invents a
      // credential this pack's quality.body does not already state.
      var credentials = Array.isArray(quality.credentials)
        ? quality.credentials.filter(function (item) { return item && typeof item.title === 'string' && item.title.trim(); })
        : [];
      if (!credentials.length) grid.classList.add('hh-pdp__story-quality-grid--copy-only');
      if (credentials.length) {
        var credentialsWrap = document.createElement('div');
        credentialsWrap.className = 'hh-pdp__story-credentials';
        var credentialsLabel = document.createElement('p');
        credentialsLabel.className = 'hh-pdp__story-credentials-label';
        var credentialsLabelText = typeof quality.credentials_label === 'string'
          ? quality.credentials_label.trim()
          : '';
        credentialsLabel.textContent = credentialsLabelText || 'HealthyHey Foods LLP · Manufacturing credentials';
        credentialsWrap.appendChild(credentialsLabel);
        var credentialsList = document.createElement('ul');
        credentialsList.setAttribute('role', 'list');
        credentials.forEach(function (credential) {
          var li = document.createElement('li');
          var mark = document.createElement('span');
          mark.className = 'hh-pdp__story-document';
          mark.setAttribute('aria-hidden', 'true');
          li.appendChild(mark);
          var h3 = document.createElement('h3');
          h3.textContent = credential.title.trim();
          li.appendChild(h3);
          if (credential.body) {
            var p = document.createElement('p');
            p.textContent = credential.body;
            li.appendChild(p);
          }
          credentialsList.appendChild(li);
        });
        credentialsWrap.appendChild(credentialsList);
        grid.appendChild(credentialsWrap);
      }

      section.appendChild(grid);

      // Mirrors the full-width "Test reports" proof strip: a grid sibling,
      // not a grid cell, same as hh-pdp-story.liquid's .hh-pdp__story-proof.
      var reports = pack && pack.reports;
      var safeLinks = reports && Array.isArray(reports.links)
        ? reports.links.filter(function (item) { return item && item.label && safeContentUrl(item.url); })
        : [];
      if (safeLinks.length) {
        var proofWrap = document.createElement('div');
        proofWrap.className = 'hh-pdp__story-proof';
        var proofCopy = document.createElement('div');
        var proofHeading = document.createElement('h3');
        proofHeading.textContent = 'Test reports';
        proofCopy.appendChild(proofHeading);
        if (reports.note) {
          var reportsNote = document.createElement('p');
          reportsNote.textContent = reports.note;
          proofCopy.appendChild(reportsNote);
        }
        proofWrap.appendChild(proofCopy);
        var reportsList = buildContentLinks(safeLinks, 'hh-pdp__story-text-link');
        proofWrap.appendChild(reportsList);
        section.appendChild(proofWrap);
      }

      section.setAttribute('aria-labelledby', heading.id);
      return section;
    }

    function updateStoryBenefits(pack) {
      if (!benefitsEl) return;
      var productTitle = root.getAttribute('data-product-title') || '';
      benefitsEl.textContent = '';
      var benefitsSection = buildStoryBenefitsSection(pack, productTitle);
      if (benefitsSection) benefitsEl.appendChild(benefitsSection);
      benefitsEl.hidden = !benefitsSection;
    }

    function updateStory(pack) {
      if (!storyEl) return;
      storyEl.textContent = ''; // clears child nodes without interpolating anything
      var servingSection = buildStoryServingSection(pack);
      var qualitySection = buildStoryQualitySection(pack);
      if (servingSection) storyEl.appendChild(servingSection);
      if (qualitySection) storyEl.appendChild(qualitySection);
      storyEl.hidden = !servingSection && !qualitySection;
    }

    function updateManufacturer(pack) {
      if (!manufacturerSlot) return;
      manufacturerSlot.textContent = '';
      manufacturerSlot.hidden = true;
      var module = pack && pack.manufacturer;
      var card = module && module.card;
      if (!module || module.approved !== true || !card || typeof card.heading !== 'string' ||
          !card.heading.trim() || typeof card.lead !== 'string' || !card.lead.trim()) return;
      var section = document.createElement('section');
      section.className = 'hh-pdp-manufacturer';
      var copy = document.createElement('div');
      copy.className = 'hh-pdp-manufacturer__copy';
      function text(tag, className, value, parent) {
        var node = document.createElement(tag);
        node.className = className;
        node.textContent = value;
        parent.appendChild(node);
        return node;
      }
      if (card.eyebrow) text('p', 'hh-pdp-manufacturer__eyebrow', card.eyebrow, copy);
      var heading = text('h2', 'hh-pdp-manufacturer__heading', card.heading.trim(), copy);
      heading.id = 'hh-pdp-manufacturer-heading-' + sectionId;
      section.setAttribute('aria-labelledby', heading.id);
      text('p', 'hh-pdp-manufacturer__body', card.lead.trim(), copy);
      var links = document.createElement('div');
      links.className = 'hh-pdp-manufacturer__links';
      (Array.isArray(card.links) ? card.links : []).forEach(function (item) {
        if (!item || !item.label || typeof item.url !== 'string' || !/^https:\/\//.test(item.url.trim())) return;
        var url = safeContentUrl(item.url.trim());
        if (!url) return;
        var link = text('a', 'hh-pdp-manufacturer__link', item.label, links);
        link.href = url;
      });
      copy.appendChild(links);
      section.appendChild(copy);
      var items = Array.isArray(card.items) ? card.items : [];
      if (items.length === 3) {
        var route = document.createElement('hh-pdp-manufacturer-route');
        route.className = 'hh-pdp-manufacturer__route';
        route.innerHTML = '<svg class="hh-pdp-manufacturer__route-svg" viewBox="0 0 300 64" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path class="hh-pdp-manufacturer__route-track" d="M50 32 L250 32" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><circle class="hh-pdp-manufacturer__route-packet" cx="50" cy="32" r="4" fill="currentColor"/></svg>';
        var steps = document.createElement('ul');
        steps.className = 'hh-pdp-manufacturer__steps';
        steps.setAttribute('role', 'list');
        items.forEach(function (item, index) {
          var step = document.createElement('li');
          step.className = 'hh-pdp-manufacturer__step';
          step.setAttribute('data-hh-mfr-step', String(index + 1));
          var disc = document.createElement('span');
          disc.className = 'hh-pdp-manufacturer__disc';
          disc.innerHTML = iconSvg(item.icon).replace('hh-pdp__icon', 'hh-pdp-manufacturer__icon');
          step.appendChild(disc);
          text('h3', '', item.label || '', step);
          text('p', '', item.value || '', step);
          steps.appendChild(step);
        });
        route.appendChild(steps);
        section.appendChild(route);
        var toggle = document.createElement('button');
        toggle.className = 'hh-pdp-manufacturer__toggle';
        toggle.type = 'button';
        toggle.hidden = true;
        toggle.setAttribute('data-hh-mfr-toggle', '');
        toggle.setAttribute('aria-pressed', 'false');
        var pause = manufacturerSlot.getAttribute('data-pause') || '';
        var play = manufacturerSlot.getAttribute('data-play') || '';
        toggle.setAttribute('data-pause', pause);
        toggle.setAttribute('data-play', play);
        toggle.innerHTML = '<svg class="hh-pdp-manufacturer__toggle-icon hh-pdp-manufacturer__toggle-icon--pause" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="8" y="6" width="3" height="12" rx="1" fill="currentColor"/><rect x="13" y="6" width="3" height="12" rx="1" fill="currentColor"/></svg><svg class="hh-pdp-manufacturer__toggle-icon hh-pdp-manufacturer__toggle-icon--play" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 6l9 6-9 6z" fill="currentColor"/></svg>';
        var label = text('span', 'hh-pdp-manufacturer__toggle-text', pause, toggle);
        label.setAttribute('data-hh-mfr-toggle-label', '');
        section.appendChild(toggle);
      }
      manufacturerSlot.appendChild(section);
      manufacturerSlot.hidden = false;
    }

    // Owns the purchase-column capsule slot independently of storyEl: the slot
    // is rebuilt from this exact pack's own record on every pack switch, the
    // previously built <hh-pdp-capsule-motion> is removed first (disconnecting
    // it pauses/unloads its video), and the slot is hidden again whenever the
    // newly selected pack carries no approved opt-in — the same gate
    // sections/hh-pdp.liquid applies on the first render, so the two can never
    // disagree.
    function updateCapsuleSlot(pack) {
      if (!capsuleSlotEl) return;
      capsuleSlotEl.textContent = '';
      var capsuleSection = buildCapsuleMotionSection(pack);
      if (capsuleSection) capsuleSlotEl.appendChild(capsuleSection);
      capsuleSlotEl.hidden = !capsuleSection;
    }

    function updateBenefit(pack) {
      if (!benefitEl) return;
      var text = (pack && pack.benefit_line) || (typedPresence[String(selectedVariantId)] === true ? '' : defaultBenefit) || '';
      benefitEl.textContent = text;
      benefitEl.hidden = !text;
    }

    function updateHighlight(pack) {
      if (!highlightEl) return;
      var text = pack && typeof pack.highlight_text === 'string' ? pack.highlight_text.trim() : '';
      highlightEl.textContent = text;
      highlightEl.hidden = !text;
    }

    function updateElemental(pack) {
      if (!elementalEl) return;
      var hasAmount = !!(pack && pack.elemental_amount);
      elementalEl.hidden = !hasAmount;
      if (elementalAmount) elementalAmount.textContent = hasAmount ? pack.elemental_amount : '';
      if (elementalLabel) {
        var hasLabel = hasAmount && !!pack.elemental_label;
        elementalLabel.textContent = hasLabel ? pack.elemental_label : '';
        elementalLabel.hidden = !hasLabel;
      }
      if (servingLabel) {
        var hasServing = hasAmount && !!pack.serving_label;
        servingLabel.textContent = hasServing ? pack.serving_label : '';
        servingLabel.hidden = !hasServing;
      }
      if (descriptorEl) {
        var hasDescriptor = hasAmount && !!pack.descriptor;
        descriptorEl.textContent = hasDescriptor ? pack.descriptor : '';
        descriptorEl.hidden = !hasDescriptor;
      }
    }

    function iconSvg(name) {
      switch (name) {
        case 'list':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 6h2m4 0h10M4 12h2m4 0h10M4 18h2m4 0h10" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'leaf':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20c8 0 16-6 16-16-8 0-16 6-16 16z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
        case 'truck':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="2" y="7" width="12" height="9" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M14 10h4l3 3v3h-7z" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="6" cy="18" r="1.5" fill="currentColor"/><circle cx="17" cy="18" r="1.5" fill="currentColor"/></svg>';
        case 'flask':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 3h6M10 3v6l-5 9a2 2 0 0 0 2 3h10a2 2 0 0 0 2-3l-5-9V3" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
        case 'clock':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M12 7v5l3.5 2" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'document':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 2.5h8l4 4V21H6zM14 2.5V7h4M9 11h6M9 15h6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'percent':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 19 19 5M7 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM17 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'star':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m12 3 2.6 5.6 6.1.8-4.4 4.3 1 6.1L12 17l-5.3 2.8 1-6.1-4.4-4.3 6.1-.8Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>';
        case 'question':
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/><path d="M9.3 9.2a2.7 2.7 0 1 1 3.6 2.6c-.6.2-.9.7-.9 1.3v.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="16.7" r="1" fill="currentColor"/></svg>';
        case 'sleep':
          return '<svg class="hh-pdp__icon" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><path d="M29 27A14 14 0 0 1 14 6a14 14 0 1 0 15 21Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="m28 6 1.5 4.5L34 12l-4.5 1.5L28 18l-1.5-4.5L22 12l4.5-1.5Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'muscle':
          return '<svg class="hh-pdp__icon" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><path d="M7 26c1-7 5-12 10-13l4 7m-4-7-2-5 5-3 6 6-3 7c8-3 13 3 10 9-4 8-19 8-26-1Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12 25c4 2 9 2 13-1" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'nerve':
          return '<svg class="hh-pdp__icon" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><circle cx="20" cy="20" r="5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="m20 15-4-6 2-4m6 12 7-7 4 1m-10 11 7 3 2 7m-15-7-5 7-5 1m6-14-8-4-3 2m17 10 2 8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'heart':
          return '<svg class="hh-pdp__icon" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><path d="M20 33C20 33 7 25.4 7 16.8A7.3 7.3 0 0 1 20 12.2a7.3 7.3 0 0 1 13 4.6C33 25.4 20 33 20 33Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'brain':
          return '<svg class="hh-pdp__icon" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><path d="M20 11.5V32m0-20.5a5 5 0 0 0-8.9-3.1 4.6 4.6 0 0 0-3.6 6.1 5 5 0 0 0 .8 8.2 5 5 0 0 0 7 4.9 4.6 4.6 0 0 0 4.7-2.6m0-16.5a5 5 0 0 1 8.9-3.1 4.6 4.6 0 0 1 3.6 6.1 5 5 0 0 1-.8 8.2 5 5 0 0 1-7 4.9 4.6 4.6 0 0 1-4.7-2.6" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        case 'eye':
          return '<svg class="hh-pdp__icon" viewBox="0 0 40 40" aria-hidden="true" focusable="false"><path d="M4 20s6.4-9 16-9 16 9 16 9-6.4 9-16 9S4 20 4 20Z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="20" cy="20" r="4.2" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
        default:
          return '<svg class="hh-pdp__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 2l8 4v6c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6z" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
      }
    }

    function buildDisclosureNode(item) {
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure';
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg(item.icon);
      var titleSpan = document.createElement('span');
      titleSpan.textContent = item.title || '';
      summary.appendChild(titleSpan);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      body.textContent = item.body || '';
      appendStoryExtras(body, item, true, true);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    // Mirrors the papers-note branch of hh-pdp-disclosures.liquid: this exact
    // pack's own papers_note when it supplies one, otherwise the generic,
    // ingredient-neutral sentence. Neither renderer ships an
    // ingredient-specific sentence any more, so no pack can inherit another
    // formulation's note on either the first paint or a variant rebuild.
    function papersNoteText(note) {
      var text = typeof note === 'string' ? note.trim() : '';
      return text || 'Published research is not a test of this finished product. Study doses are context, not directions for use.';
    }

    function buildCitationsNode(citations, papersNote) {
      if (!Array.isArray(citations)) return null;
      var safeCitations = citations.filter(function (citation) {
        return citation && citation.label && typeof citation.url === 'string' && citation.url.indexOf('https://') === 0;
      });
      if (!safeCitations.length) return null;
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--papers';
      details.id = 'hh-pdp-papers-' + sectionId;
      details.setAttribute('data-hh-pdp-papers', '');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('document');
      var titleSpan = document.createElement('span');
      titleSpan.textContent = 'Scientific papers';
      summary.appendChild(titleSpan);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var note = document.createElement('p');
      note.className = 'hh-pdp__papers-note';
      note.textContent = papersNoteText(papersNote);
      body.appendChild(note);
      var list = document.createElement('ul');
      list.className = 'hh-pdp__papers-list';
      safeCitations.forEach(function (citation) {
        var li = document.createElement('li');
        li.className = 'hh-pdp__paper';
        var link = document.createElement('a');
        link.href = citation.url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.textContent = citation.label;
        link.setAttribute('aria-label', citation.label + ' (opens in a new tab)');
        li.appendChild(link);
        [['Finding:', 'summary'], ['Limitations:', 'limitation'], ['Relevance to this pack:', 'relevance']].forEach(function (entry) {
          if (!citation[entry[1]]) return;
          var paragraph = document.createElement('p');
          var heading = document.createElement('strong');
          heading.textContent = entry[0] + ' ';
          paragraph.appendChild(heading);
          var value = document.createElement('span');
          value.textContent = citation[entry[1]];
          paragraph.appendChild(value);
          li.appendChild(paragraph);
        });
        if (citation.doi) {
          var doi = document.createElement('span');
          doi.className = 'hh-pdp__paper-doi';
          doi.textContent = 'DOI: ' + citation.doi;
          li.appendChild(doi);
        }
        list.appendChild(li);
      });
      body.appendChild(list);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    // Mirrors the format-comparison branch of hh-pdp-disclosures.liquid: same
    // gate (format_comparison.approved === true plus a supplied title and at
    // least one body field), same order (after Scientific papers, before the
    // pack's own disclosures), same copy source (the pack entry only — there
    // is no generic SKU copy here).
    function buildFormatComparisonNode(comparison) {
      if (!comparison || comparison.approved !== true || !comparison.title) return null;
      var rows = Array.isArray(comparison.rows)
        ? comparison.rows.filter(function (row) { return row && row.label && row.value; })
        : [];
      if (!comparison.intro && !comparison.caveat && !rows.length) return null;
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--format';
      details.id = 'hh-pdp-format-' + sectionId;
      details.setAttribute('data-hh-pdp-format', '');
      details.setAttribute('data-hh-pdp-kind', 'format');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('percent');
      var title = document.createElement('span');
      title.textContent = comparison.title;
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      if (comparison.intro) {
        var intro = document.createElement('p');
        intro.className = 'hh-pdp__format-intro';
        intro.textContent = comparison.intro;
        body.appendChild(intro);
      }
      if (rows.length) {
        var list = document.createElement('ul');
        list.className = 'hh-pdp__format-rows';
        rows.forEach(function (row) {
          var li = document.createElement('li');
          li.className = 'hh-pdp__format-row';
          var rowLabel = document.createElement('span');
          rowLabel.className = 'hh-pdp__format-row-label';
          rowLabel.textContent = row.label;
          li.appendChild(rowLabel);
          var rowValue = document.createElement('span');
          rowValue.className = 'hh-pdp__format-row-value';
          rowValue.textContent = row.value;
          li.appendChild(rowValue);
          list.appendChild(li);
        });
        body.appendChild(list);
      }
      if (comparison.caveat) {
        var caveat = document.createElement('p');
        caveat.className = 'hh-pdp__format-caveat';
        caveat.textContent = comparison.caveat;
        body.appendChild(caveat);
      }
      var linkUrl = comparison.link ? safeMediaUrl(comparison.link.url) : '';
      if (linkUrl && comparison.link.label) {
        var link = document.createElement('a');
        link.className = 'hh-pdp__format-link';
        link.href = linkUrl;
        link.textContent = comparison.link.label;
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.appendChild(arrow);
        body.appendChild(link);
      }
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    // Mirrors the quality branch of hh-pdp-disclosures.liquid: same gate
    // (quality.approved === true plus a supplied title and body), same
    // order (after the format comparison, before the pack's own
    // disclosures), same copy source (the pack entry only — there is no
    // generic SKU copy here).
    function buildQualityNode(quality) {
      if (!quality || quality.approved !== true || !quality.title || !quality.body) return null;
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--quality';
      details.id = 'hh-pdp-quality-' + sectionId;
      details.setAttribute('data-hh-pdp-quality', '');
      details.setAttribute('data-hh-pdp-kind', 'quality');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('shield');
      var title = document.createElement('span');
      title.textContent = quality.title;
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var bodyText = document.createElement('p');
      bodyText.className = 'hh-pdp__quality-body';
      bodyText.textContent = quality.body;
      body.appendChild(bodyText);
      if (quality.note) {
        var note = document.createElement('p');
        note.className = 'hh-pdp__quality-note';
        note.textContent = quality.note;
        body.appendChild(note);
      }
      var linkUrl = quality.link ? safeMediaUrl(quality.link.url) : '';
      if (Array.isArray(quality.links) && quality.links.length) {
        var qualityLinks = buildContentLinks(quality.links, 'hh-pdp__quality-link');
        if (qualityLinks) body.appendChild(qualityLinks);
      } else if (linkUrl && quality.link.label) {
        var link = document.createElement('a');
        link.className = 'hh-pdp__quality-link';
        link.href = linkUrl;
        link.textContent = quality.link.label;
        var arrow = document.createElement('span');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        link.appendChild(arrow);
        body.appendChild(link);
      }
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    // Mirrors the FAQ branch of hh-pdp-disclosures.liquid: same gate
    // (faq.approved === true plus at least one item carrying BOTH a question
    // and an answer), same order (after the format comparison, before
    // Quality & certifications), same copy source (this exact pack's own
    // entry — there is no generic SKU copy here). Question/answer are
    // written as text nodes, so neither can ever be parsed as markup, and
    // no FAQ JSON-LD is emitted.
    function buildApprovedFaqNode(faq, labels) {
      var items = faq.items.filter(function (item) {
        return item && typeof item.question === 'string' && item.question.trim() &&
          typeof item.answer === 'string' && item.answer.trim();
      });
      if (!items.length) return null;
      var panel = document.createElement('section');
      panel.className = 'hh-pdp__approved-faq hh-pdp__disclosure--faq';
      panel.id = 'hh-pdp-faq-' + sectionId;
      panel.setAttribute('data-hh-pdp-faq', '');
      panel.setAttribute('data-hh-pdp-kind', 'faq');
      panel.setAttribute('data-hh-pdp-approved-faq', '');
      panel.setAttribute('data-variant-id', String(selectedVariantId));
      panel.setAttribute('aria-labelledby', panel.id + '-title');
      var heading = document.createElement('h3');
      heading.className = 'hh-pdp__approved-faq-title';
      heading.id = panel.id + '-title';
      heading.innerHTML = iconSvg('question');
      var title = document.createElement('span');
      title.textContent = faq.title || labels.title;
      heading.appendChild(title);
      panel.appendChild(heading);
      items.forEach(function (item) {
        var row = document.createElement('details');
        row.className = 'hh-pdp__approved-faq-item';
        var question = document.createElement('summary');
        question.className = 'hh-pdp__approved-faq-question';
        question.textContent = item.question;
        var answer = document.createElement('div');
        answer.className = 'hh-pdp__approved-faq-answer';
        answer.textContent = item.answer;
        row.appendChild(question);
        row.appendChild(answer);
        panel.appendChild(row);
      });
      return panel;
    }

    function buildFaqNode(faq, labels) {
      if (!faq || faq.approved !== true) return null;
      var items = Array.isArray(faq.items)
        ? faq.items.filter(function (item) { return item && item.question && item.answer; })
        : [];
      if (!items.length) return null;
      var preservedVariants = '44641620099357,44641507344669,44641507377437,44641507410205,49903010971933,49903011004701,49903010971901'.split(',');
      if (preservedVariants.indexOf(String(selectedVariantId)) === -1) return buildApprovedFaqNode(faq, labels);
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--faq';
      details.id = 'hh-pdp-faq-' + sectionId;
      details.setAttribute('data-hh-pdp-faq', '');
      details.setAttribute('data-hh-pdp-kind', 'faq');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('question');
      var title = document.createElement('span');
      title.textContent = faq.title || labels.title;
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var list = document.createElement('dl');
      list.className = 'hh-pdp__faq-list';
      items.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'hh-pdp__faq-item';
        var question = document.createElement('dt');
        question.className = 'hh-pdp__faq-question';
        question.textContent = item.question;
        row.appendChild(question);
        var answer = document.createElement('dd');
        answer.className = 'hh-pdp__faq-answer';
        answer.textContent = item.answer;
        row.appendChild(answer);
        list.appendChild(row);
      });
      body.appendChild(list);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function buildFallbackDisclosureNode() {
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure';
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('shield');
      var titleSpan = document.createElement('span');
      titleSpan.textContent = 'Label information';
      summary.appendChild(titleSpan);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      body.textContent =
        'Detailed label information for this pack is pending QA approval and will be added before launch. ' +
        'See the product packaging for ingredient and usage information in the meantime.';
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function buildFactsNode(facts) {
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--facts';
      details.open = true;
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('list');
      var title = document.createElement('span');
      title.textContent = 'Product facts';
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var table = document.createElement('table');
      table.className = 'hh-pdp__facts-table';
      var tbody = document.createElement('tbody');
      facts.forEach(function (fact) {
        if (!fact || !fact.label || !fact.value) return;
        var row = document.createElement('tr');
        var label = document.createElement('th');
        label.setAttribute('scope', 'row');
        label.textContent = fact.label;
        var value = document.createElement('td');
        value.textContent = fact.value;
        row.appendChild(label);
        row.appendChild(value);
        tbody.appendChild(row);
      });
      if (!tbody.children.length) return null;
      table.appendChild(tbody);
      body.appendChild(table);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function buildLabelNode(label) {
      if (!label) return null;
      var ingredients = Array.isArray(label.ingredients) ? label.ingredients : [];
      if (!ingredients.length && !safeMediaUrl(label.image_url)) return null;
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--label';
      details.id = 'hh-pdp-ingredients-' + sectionId;
      details.setAttribute('data-hh-pdp-label', '');
      details.setAttribute('data-hh-pdp-kind', 'label');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('leaf');
      var title = document.createElement('span');
      title.textContent = 'Ingredients & label';
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var layout = document.createElement('div');
      layout.className = 'hh-pdp__label-layout';
      var copy = document.createElement('div');
      var caption = document.createElement('p');
      caption.className = 'hh-pdp__label-caption';
      caption.textContent = label.caption || 'Ingredients listed on this pack';
      copy.appendChild(caption);
      var list = document.createElement('ul');
      list.className = 'hh-pdp__label-ingredients';
      ingredients.forEach(function (ingredient) {
        if (!ingredient) return;
        var li = document.createElement('li');
        li.textContent = ingredient;
        list.appendChild(li);
      });
      if (list.children.length) copy.appendChild(list);
      layout.appendChild(copy);
      var imageUrl = safeMediaUrl(label.image_url);
      if (imageUrl) {
        var link = document.createElement('a');
        link.className = 'hh-pdp__label-image-link';
        link.href = imageUrl;
        link.target = '_blank';
        link.rel = 'noopener';
        link.setAttribute('aria-label', 'Open full ingredient label image');
        var img = document.createElement('img');
        img.className = 'hh-pdp__label-image';
        img.src = imageUrl;
        img.alt = label.image_alt || '';
        img.loading = 'lazy';
        img.width = Number(label.image_width) || 900;
        img.height = Number(label.image_height) || 1500;
        link.appendChild(img);
        var linkText = document.createElement('span');
        linkText.textContent = 'View full label';
        link.appendChild(linkText);
        layout.appendChild(link);
      }
      body.appendChild(layout);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    // Mirrors the usage branch of hh-pdp-disclosures.liquid: a plain string
    // renders as newline-separated paragraphs; a non-empty *_items array
    // (exact, unsplit sentences) renders as a list instead and takes
    // priority over the matching plain-string field. Headings come from the
    // same translated usageLabels the server rendered, via the
    // [data-hh-pdp-usage-labels] JSON island, so the two never disagree.
    function buildUsageSection(heading, lines, asList) {
      var section = document.createElement('div');
      section.className = 'hh-pdp__usage-section';
      var h3 = document.createElement('h3');
      h3.className = 'hh-pdp__usage-heading';
      h3.textContent = heading;
      section.appendChild(h3);
      if (asList) {
        var list = document.createElement('ul');
        list.className = 'hh-pdp__usage-list';
        lines.forEach(function (line) {
          if (!line) return;
          var li = document.createElement('li');
          li.textContent = line;
          list.appendChild(li);
        });
        section.appendChild(list);
      } else {
        lines.forEach(function (line) {
          if (!line) return;
          var p = document.createElement('p');
          p.textContent = line;
          section.appendChild(p);
        });
      }
      return section;
    }

    function buildUsageNode(usage, labels) {
      if (!usage || usage.approved !== true) return null;
      var hasPrecautionItems = Array.isArray(usage.precautions_items) && usage.precautions_items.filter(Boolean).length > 0;
      var hasStorageItems = Array.isArray(usage.storage_items) && usage.storage_items.filter(Boolean).length > 0;
      var hasDirections = !!usage.directions;
      var hasPrecautions = hasPrecautionItems || !!usage.precautions;
      var hasStorage = hasStorageItems || !!usage.storage;
      if (!hasDirections && !hasPrecautions && !hasStorage) return null;

      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--usage';
      details.setAttribute('data-hh-pdp-usage', '');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('clock');
      var title = document.createElement('span');
      title.textContent = 'How to use & precautions';
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';

      if (hasDirections) {
        body.appendChild(buildUsageSection(labels.directions, usage.directions.split('\n'), false));
      }
      if (hasPrecautionItems) {
        body.appendChild(buildUsageSection(labels.precautions, usage.precautions_items.filter(Boolean), true));
      } else if (usage.precautions) {
        body.appendChild(buildUsageSection(labels.precautions, usage.precautions.split('\n'), false));
      }
      if (hasStorageItems) {
        body.appendChild(buildUsageSection(labels.storage, usage.storage_items.filter(Boolean), true));
      } else if (usage.storage) {
        body.appendChild(buildUsageSection(labels.storage, usage.storage.split('\n'), false));
      }

      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function buildReportsNode(reports) {
      if (!reports || !Array.isArray(reports.links)) return null;
      var safeLinks = reports.links.filter(function (item) { return item && item.label && safeContentUrl(item.url); });
      if (!safeLinks.length) return null;
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--reports';
      details.id = 'hh-pdp-reports-' + sectionId;
      details.setAttribute('data-hh-pdp-reports', '');
      details.setAttribute('data-hh-pdp-kind', 'reports');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('flask');
      var title = document.createElement('span');
      title.textContent = 'Testing & reports';
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      if (reports.note) {
        var note = document.createElement('p');
        note.textContent = reports.note;
        body.appendChild(note);
      }
      var list = buildContentLinks(safeLinks);
      body.appendChild(list);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function buildDeliveryNode(delivery) {
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--delivery';
      details.id = 'hh-pdp-delivery-' + sectionId;
      details.setAttribute('data-hh-pdp-kind', 'delivery');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('truck');
      var title = document.createElement('span');
      title.textContent = 'Delivery & returns';
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var note = document.createElement('p');
      note.textContent = delivery && delivery.body || 'Delivery availability and final charges are shown at checkout. See the applicable policy terms:';
      body.appendChild(note);
      var list = document.createElement('div');
      list.className = 'hh-pdp__delivery-links';
      if (delivery && Array.isArray(delivery.links) && delivery.links.length) {
        var authoredLinks = buildContentLinks(delivery.links, 'hh-pdp__delivery-link');
        if (authoredLinks) list.appendChild(authoredLinks);
      } else {
        var deliveryLinks = [
          ['Shipping policy', '/policies/shipping-policy'],
          ['Money-back guarantee & terms', '/pages/healthyhey-nutrition-money-back-guarantee'],
          ['Partial cash-on-delivery terms', '/pages/partial-payment-for-cash-on-delivery-cod']
        ];
      deliveryLinks.forEach(function (item) {
        var link = document.createElement('a');
        link.className = 'hh-pdp__delivery-link';
        link.href = item[1];
        var label = document.createElement('span');
        label.className = 'hh-pdp__delivery-link-label';
        label.textContent = item[0];
        link.appendChild(label);
        list.appendChild(link);
      });
      }
      body.appendChild(list);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function buildReviewsNode() {
      var details = document.createElement('details');
      details.className = 'hh-pdp__disclosure hh-pdp__disclosure--reviews';
      details.id = HH_REVIEWS_DISCLOSURE_PREFIX + sectionId;
      details.setAttribute('data-hh-pdp-kind', 'reviews');
      var summary = document.createElement('summary');
      summary.className = 'hh-pdp__disclosure-summary';
      summary.innerHTML = iconSvg('star');
      var title = document.createElement('span');
      title.textContent = 'Customer reviews';
      summary.appendChild(title);
      var body = document.createElement('div');
      body.className = 'hh-pdp__disclosure-body';
      var slot = document.createElement('div');
      slot.className = 'hh-pdp__review-slot';
      slot.setAttribute('data-hh-pdp-review-slot', '');
      var fallback = document.createElement('a');
      fallback.className = 'hh-pdp__review-fallback';
      fallback.setAttribute('data-hh-pdp-review-fallback', '');
      fallback.textContent = 'Read all product reviews ↓';
      slot.appendChild(fallback);
      syncReviewFallbackLink(fallback, reviewsAppAnchor, document);
      body.appendChild(slot);
      details.appendChild(summary);
      details.appendChild(body);
      return details;
    }

    function updateDisclosures(pack) {
      if (!disclosuresEl) return;
      // Customer reviews is product-level (same product, every pack), not
      // pack-specific: reuse the exact same node across a pack switch
      // instead of rebuilding it, so a review list the app has already
      // moved into its slot (see initReviews()) survives the
      // `innerHTML = ''` reset below rather than being discarded.
      var existingReviewsNode = disclosuresEl.querySelector('[data-hh-pdp-kind="reviews"]');
      // The public '#product-reviews' alias target is product-level in the
      // same way: keep the exact node the server rendered instead of emitting
      // a second element carrying that id on every rebuild.
      var existingReviewAnchor = disclosuresEl.querySelector('[data-hh-pdp-review-anchor]');
      disclosuresEl.innerHTML = '';
      if (pack && Array.isArray(pack.facts) && pack.facts.length) {
        var factsNode = buildFactsNode(pack.facts);
        if (factsNode) disclosuresEl.appendChild(factsNode);
      }
      var labelNode = buildLabelNode(pack && pack.label);
      if (labelNode) disclosuresEl.appendChild(labelNode);
      var usageNode = buildUsageNode(pack && pack.usage, usageLabels);
      if (usageNode) disclosuresEl.appendChild(usageNode);
      var reportsNode = buildReportsNode(pack && pack.reports);
      if (reportsNode) disclosuresEl.appendChild(reportsNode);
      var papersNode = buildCitationsNode(pack && pack.citations, pack && pack.papers_note);
      if (papersNode) disclosuresEl.appendChild(papersNode);
      var formatNode = buildFormatComparisonNode(pack && pack.format_comparison);
      if (formatNode) disclosuresEl.appendChild(formatNode);
      var faqNode = buildFaqNode(pack && pack.faq, faqLabels);
      var preserveFaqPosition = '44641620099357,44641507344669,44641507377437,44641507410205,49903010971933,49903011004701,49903010971901'.split(',').indexOf(String(selectedVariantId)) !== -1;
      if (faqNode && preserveFaqPosition) disclosuresEl.appendChild(faqNode);
      var qualityNode = buildQualityNode(pack && pack.quality);
      if (qualityNode) disclosuresEl.appendChild(qualityNode);
      if (pack && pack.disclosures && pack.disclosures.length) {
        pack.disclosures.forEach(function (item) {
          disclosuresEl.appendChild(buildDisclosureNode(item));
        });
      } else if (!labelNode && !usageNode && !reportsNode && !papersNode) {
        disclosuresEl.appendChild(buildFallbackDisclosureNode());
      }
      appendReviewAnchorAlias(disclosuresEl, existingReviewAnchor, reviewAnchorId, document);
      disclosuresEl.appendChild(existingReviewsNode || buildReviewsNode());
      disclosuresEl.appendChild(buildDeliveryNode(pack && pack.delivery));
      if (faqNode && !preserveFaqPosition) disclosuresEl.appendChild(faqNode);
      var headingKinds = {facts:'facts',ingredients:'label',usage:'usage',reports:'reports',papers:'papers',comparison:'format',faq:'faq',quality:'quality',delivery:'delivery'};
      Object.keys(headingKinds).forEach(function (key) {
        var text = pack && pack.headings && pack.headings[key];
        if (typeof text !== 'string' || !text.trim()) return;
        var heading = disclosuresEl.querySelector(key === 'faq' ? '.hh-pdp__approved-faq-title > span, .hh-pdp__disclosure--faq > summary > span' : '.hh-pdp__disclosure--' + headingKinds[key] + ' > summary > span');
        if (heading) heading.textContent = text;
      });
      quickLinks.forEach(function (link) {
        var kind = link.getAttribute('data-hh-pdp-quick');
        if (kind === 'label') link.hidden = !labelNode;
        if (kind === 'reports') link.hidden = !reportsNode;
      });
    }

    function selectVariant(variantId, options) {
      options = options || {};
      var variant = findVariant(variantId);
      if (!variant) return;
      // Re-selecting the current pack must not rebuild media or restart video.
      if (String(variantId) === String(selectedVariantId)) return;
      selectedVariantId = variantId;
      var pack = getApprovedPack(variantId);
      if (select && String(select.value) !== String(variantId)) select.value = variantId;
      updatePills(variantId);
      updatePrice(variant);
      updateAtc(variant);
      updateRightToKnow(variantId);
      refreshOfferDisplay();
      updateGallery(variantId);
      updateStoryBenefits(pack);
      updateStory(pack);
      updateManufacturer(pack);
      updateBenefit(pack);
      updateHighlight(pack);
      updatePurchaseComparison(pack, variantId);
      updateElemental(pack);
      updateCapsuleSlot(pack);
      updateDisclosures(pack);
      updateReassurance(pack, variantId);
      updateAlternatives(alternativesMount, alternativesMap, variantId);
      if (!options.skipUrl) updateUrl(variantId);
    }

    if (select) {
      listen(select, 'change', function () {
        selectVariant(select.value, { skipUrl: restoringHistory });
      });
    }

    pills.forEach(function (pill) {
      listen(pill, 'click', function () {
        if (pill.disabled) return;
        var id = pill.getAttribute('data-variant-id');
        if (select && typeof window.Event === 'function' && typeof select.dispatchEvent === 'function') {
          select.value = id;
          // Native form and purchase apps observe the same exact variant.
          select.dispatchEvent(new window.Event('change', { bubbles: true }));
        } else {
          selectVariant(id);
        }
      });
    });

    // History belongs to this section owner, not an accumulating global
    // listener. App-specific purchase compatibility is a separate gate.
    if (root.__hhPdpHistoryDispose) root.__hhPdpHistoryDispose();
    if (typeof window.addEventListener === 'function') {
      var restoreVariantFromUrl = function () {
        if (owner.destroyed) return;
        var url = new URL(window.location.href);
        if (root.isConnected === false || url.pathname !== productPath) return;
        var id = url.searchParams.get('variant');
        // Unknown explicit IDs must not be translated to another pack.
        if (id && !findVariant(id)) return;
        id = id || initialVariantId;
        if (!findVariant(id) || String(id) === String(selectedVariantId)) return;
        restoringHistory = true;
        try {
          if (select && typeof window.Event === 'function' && typeof select.dispatchEvent === 'function') {
            select.value = String(id);
            select.dispatchEvent(new window.Event('change', { bubbles: true }));
          } else {
            selectVariant(id, { skipUrl: true });
          }
        } finally {
          restoringHistory = false;
        }
      };
      var onSectionUnload = function (event) {
        var target = event.target;
        if (target === root || (target && target.contains && target.contains(root))) disposeHistory();
      };
      var disposeHistory = function () {
        window.removeEventListener('popstate', restoreVariantFromUrl);
        document.removeEventListener('shopify:section:unload', onSectionUnload);
        if (root.__hhPdpHistoryDispose === disposeHistory) delete root.__hhPdpHistoryDispose;
      };
      root.__hhPdpHistoryDispose = disposeHistory;
      owner.onCleanup(disposeHistory);
      window.addEventListener('popstate', restoreVariantFromUrl);
      document.addEventListener('shopify:section:unload', onSectionUnload);
    }

    function showAtcError(message) {
      if (!atcError) return;
      atcError.textContent = message;
      atcError.hidden = false;
    }

    function clearAtcError() {
      if (!atcError) return;
      atcError.hidden = true;
      atcError.textContent = '';
    }

    // Progressive enhancement over the plain /cart/add form: this submits
    // the exact variant [name=id] and integer quantity the shopper already
    // selected (same fields the no-JS fallback posts), via fetch so we can
    // surface a real error inline and land on /cart only on confirmed
    // success, instead of trusting a bare browser navigation to /cart/add
    // that gives no feedback if it silently fails. If fetch is unavailable
    // the native form submission below still runs untouched. FormData
    // preserves selling plans, properties, files and form-associated fields;
    // it does not establish compatibility with app-owned bundle requests.
    //
    // Reached from two independent triggers that must still add the item
    // exactly once: the form's native 'submit' event (keyboard Enter, or any
    // non-click implicit submission) and a 'click' listener bound directly
    // on the button itself (see below) — added because some other script on
    // this storefront intercepts clicks that land on the button's inner
    // label span (pointer-events: auto) before the browser's default submit
    // action runs, so a real pointer click on the visible CTA was silently
    // doing nothing even though the button and form were otherwise intact.
    // `pending` is the single guard shared by both triggers.
    var addToCartPending = false;
    var cartRequest = null;
    owner.onCleanup(function () {
      if (cartRequest) cartRequest.abort();
    });

    function performAddToCart() {
      if (owner.destroyed || addToCartPending) return;
      if (!atcButton || atcButton.disabled) return;

      var variantId = (select && select.value) || selectedVariantId;
      var variant = findVariant(variantId);
      if (!variant || !variant.available) {
        showAtcError('This pack is sold out.');
        return;
      }
      if (typeof cartForm.reportValidity === 'function' && !cartForm.reportValidity()) return;
      var quantity = Number(qtyInput ? qtyInput.value : 1);
      if (!Number.isSafeInteger(quantity) || quantity < 1) {
        showAtcError((commerceLabels && commerceLabels.getAttribute('data-invalid-quantity')) || 'Please choose a whole-number quantity of at least 1.');
        return;
      }
      var formData = new window.FormData(cartForm);
      formData.set('id', String(variantId));
      formData.set('quantity', String(quantity));
      var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      if (cartRoot.charAt(cartRoot.length - 1) !== '/') cartRoot += '/';

      clearAtcError();
      addToCartPending = true;
      atcButton.disabled = true;
      cartRequest = typeof window.AbortController === 'function' ? new window.AbortController() : null;

      window
        .fetch(cartRoot + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
          signal: cartRequest ? cartRequest.signal : undefined
        })
        .then(function (response) {
          return response.json().then(function (data) {
            if (!response.ok) {
              throw new Error((data && data.description) || 'Could not add this item to your cart.');
            }
            return data;
          });
        })
        .then(function () {
          if (owner.destroyed) return;
          cartRequest = null;
          window.location.href = cartRoot + 'cart';
        })
        .catch(function (error) {
          if (owner.destroyed) return;
          cartRequest = null;
          showAtcError((error && error.message) || 'Could not add this item to your cart.');
          addToCartPending = false;
          var currentVariant = findVariant((select && select.value) || selectedVariantId);
          atcButton.disabled = !currentVariant || !currentVariant.available;
        });
    }

    if (cartForm && typeof window.fetch === 'function' && typeof window.FormData === 'function') {
      listen(cartForm, 'submit', function (event) {
        event.preventDefault();
        performAddToCart();
      });

      // Bound directly on the button (the event target, not a delegated
      // ancestor) so it still runs even if some other script's handler
      // higher up the tree calls stopPropagation()/preventDefault() on the
      // click before it would otherwise reach the form's default submit
      // action. Calling preventDefault() here makes this the single path
      // for a pointer click, so the browser never also fires its own
      // implicit 'submit' for the same click and double-adds the item.
      if (atcButton) {
        listen(atcButton, 'click', function (event) {
          event.preventDefault();
          performAddToCart();
        });
      }
    }

    quickLinks.forEach(function (link) {
      listen(link, 'click', function () {
        var kind = link.getAttribute('data-hh-pdp-quick');
        var target = disclosuresEl && disclosuresEl.querySelector('[data-hh-pdp-kind="' + kind + '"]');
        if (target) target.open = true;
      });
    });

    listen(root, 'click', function (event) {
      var link = event.target.closest('[data-hh-pdp-story-disclosure]');
      if (!link || !root.contains(link)) return;
      var target = root.querySelector(link.getAttribute('href'));
      if (target && target.tagName === 'DETAILS') target.open = true;
    });

    function scrollToReviews() {
      openReviewsDisclosure(disclosuresEl, true);
    }

    // Clicking the product rating (the app's own title-rating stars, or
    // this section's rating-metafield fallback button) opens and scrolls to
    // Customer reviews instead of doing nothing. Delegated on `root` via a
    // real click listener only, same as the app's reference implementation
    // — a real button/link fires 'click' on Enter/Space too, so this does
    // not need its own keydown handling to stay keyboard-operable.
    listen(root, 'click', function (e) {
      var trigger = e.target && e.target.closest && e.target.closest('.areviews_header_stars, [data-hh-pdp-rating]');
      if (!trigger) return;
      scrollToReviews();
    });

    if (pillsWrap) {
      pillsWrap.hidden = false;
      root.classList.add('is-enhanced');
    }

    refreshOfferDisplay();
    initAppstleOfferObserver(root, refreshOfferDisplay, function () {
      return (select && select.value) || selectedVariantId;
    }, owner);

    wireExistingGallery(root, galleryMap, galleryItemsRef, owner);
    owner.onCleanup(function () {
      pauseAllVideos(galleryMain);
      // Capsule custom elements own their disconnectedCallback teardown;
      // stop motion immediately while Shopify removes this section.
      if (capsuleSlotEl) capsuleSlotEl.querySelectorAll('video').forEach(function (video) { video.pause(); });
      if (compactQtyWrap && compactQtyWrap.parentNode) compactQtyWrap.parentNode.removeChild(compactQtyWrap);
      if (qtyRow) qtyRow.hidden = nativeQtyState.rowHidden;
      if (qtyInput) {
        qtyInput.hidden = nativeQtyState.inputHidden;
        if (nativeQtyState.tabIndex === null) qtyInput.removeAttribute('tabindex');
        else qtyInput.setAttribute('tabindex', nativeQtyState.tabIndex);
      }
      var currentVariant = findVariant((select && select.value) || selectedVariantId);
      if (atcButton) atcButton.disabled = !currentVariant || !currentVariant.available;
    });
    initReviews(root, owner);
    // Validate the server-rendered fallback against the apps-section wrapper
    // that is actually on this page, then make '#product-reviews' (and this
    // section's own '#hh-pdp-reviews-<sectionId>') open the existing Customer
    // reviews disclosure on load, on hashchange and on a review-link click.
    syncReviewFallbackLink(root.querySelector('[data-hh-pdp-review-fallback]'), reviewsAppAnchor, document);
    initReviewAnchorNavigation(root, disclosuresEl, reviewAnchorId, sectionId, window, owner);

    return owner;
    } catch (error) {
      owner.destroy();
      throw error;
    }
  }

  // --- Gallery rendering/wiring, shared between the server-rendered
  // initial markup and JS-driven rebuilds on variant change. ---

  // Restricts media URLs read from JSON data islands to https:// or
  // root-relative paths before they're assigned to a src/background-image,
  // as defense in depth (belt-and-braces alongside DOM-API construction,
  // which already keeps these values out of any HTML/CSS parser).
  function safeMediaUrl(url) {
    if (typeof url !== 'string') return '';
    // Shopify's image_url filter can return protocol-relative URLs. Allow
    // only this storefront and Shopify's CDN, then make the scheme explicit.
    if (url.indexOf('//healthyhey.com/') === 0 || url.indexOf('//cdn.shopify.com/') === 0) {
      return 'https:' + url;
    }
    return url.indexOf('https://') === 0 || (url.charAt(0) === '/' && url.charAt(1) !== '/') ? url : '';
  }

  // Select exactly one encode at deferred attachment time, using the actual
  // gallery box and up to 2x display density. No resize-time source swaps:
  // they restart playback/downloads and cause a visible loop discontinuity.
  function selectHeroVideoSource(item) {
    var fallback = safeMediaUrl(item.getAttribute('data-src-mp4'));
    if (!fallback) return '';
    var sizes;
    try { sizes = JSON.parse(item.getAttribute('data-src-mp4-sizes') || 'null'); }
    catch (e) { return fallback; }
    if (!Array.isArray(sizes) || sizes.length < 2 || sizes.length > 8) return fallback;
    var seen = {};
    var candidates = [];
    for (var i = 0; i < sizes.length; i++) {
      var size = sizes[i];
      if (!size || typeof size.width !== 'number' || !isFinite(size.width) ||
          size.width < 120 || size.width > 3840 || Math.floor(size.width) !== size.width ||
          seen[size.width]) return fallback;
      var src = safeMediaUrl(size.src);
      if (!src) return fallback;
      seen[size.width] = true;
      candidates.push({ width: size.width, src: src });
    }
    if (!candidates.some(function (size) { return size.src === fallback; })) return fallback;
    var box = typeof item.getBoundingClientRect === 'function' ? item.getBoundingClientRect() : null;
    if (!box || !isFinite(box.width) || box.width <= 0) return fallback;
    var density = Number(window.devicePixelRatio);
    if (!isFinite(density) || density <= 0) density = 1;
    var target = Math.ceil(box.width * Math.max(1, Math.min(2, density)));
    candidates.sort(function (a, b) { return a.width - b.width; });
    for (var j = 0; j < candidates.length; j++) {
      if (candidates[j].width >= target) return candidates[j].src;
    }
    return candidates[candidates.length - 1].src;
  }

  // Used only when a variant is missing from the server-rendered money map
  // (e.g. a race during a storefront update); formats INR as a reasonable
  // approximation of Shopify's own money filter.
  function fallbackMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.moneyFormat) {
      return window.Shopify.formatMoney(cents, window.moneyFormat);
    }
    try {
      return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 }).format(
        cents / 100
      );
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function inrWholeRupees(cents) {
    var rupees = cents / 100;
    var digits = cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat('en-IN', {
        style: 'currency', currency: 'INR', minimumFractionDigits: digits, maximumFractionDigits: digits
      }).format(rupees);
    } catch (e) {
      return '₹' + rupees.toFixed(digits);
    }
  }

  function formatPercent(percent) {
    try {
      return new Intl.NumberFormat('en-IN', { maximumFractionDigits: 2 }).format(percent);
    } catch (e) {
      return String(percent);
    }
  }

  function safeRelativeUrl(url) {
    return typeof url === 'string' && url.charAt(0) === '/' && url.charAt(1) !== '/' ? url : '#';
  }

  // Builds a gallery item entirely from DOM nodes/properties (src, alt,
  // textContent, etc.) rather than interpolating media URLs/alt text into
  // an innerHTML string, so a value from the pack JSON data island can
  // never be parsed as markup.
  function buildItemNode(item, index, isActive, productTitle) {
    var wrap = document.createElement('div');
    wrap.className = 'hh-pdp__gallery-item' + (isActive ? ' is-active' : '');
    wrap.setAttribute('data-hh-pdp-gallery-item', '');
    wrap.setAttribute('data-index', String(index));
    wrap.setAttribute('data-type', item.type === 'video' ? 'video' : item.type === 'placeholder' ? 'placeholder' : 'image');

    var alt = item.alt || productTitle || '';

    if (item.type === 'placeholder') {
      // Mirrors theme/snippets/hh-pdp-gallery.liquid's own placeholder_svg_tag
      // branch: a neutral placeholder graphic, never another pack's photo.
      var placeholder = document.createElement('div');
      placeholder.className = 'hh-pdp__gallery-image hh-pdp__gallery-placeholder';
      wrap.appendChild(placeholder);
    } else if (item.type === 'video') {
      var posterSrc = safeMediaUrl(item.poster);
      wrap.setAttribute('data-src-mp4', safeMediaUrl(item.src_mp4));
      if (Array.isArray(item.src_mp4_sizes)) {
        wrap.setAttribute('data-src-mp4-sizes', JSON.stringify(item.src_mp4_sizes));
      }

      var posterImg = document.createElement('img');
      posterImg.src = posterSrc;
      posterImg.alt = alt;
      posterImg.className = 'hh-pdp__gallery-poster';
      posterImg.loading = index === 0 ? 'eager' : 'lazy';
      posterImg.setAttribute('fetchpriority', index === 0 ? 'high' : 'auto');
      posterImg.width = 1000;
      posterImg.height = 1000;
      wrap.appendChild(posterImg);

      var video = document.createElement('video');
      video.className = 'hh-pdp__gallery-video';
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'none';
      if (posterSrc) video.poster = posterSrc;
      video.setAttribute('aria-label', alt);
      video.hidden = true;
      wrap.appendChild(video);

      var playButton = document.createElement('button');
      playButton.type = 'button';
      playButton.className = 'hh-pdp__gallery-play';
      playButton.setAttribute('data-hh-pdp-play', '');
      playButton.setAttribute('aria-label', 'Play product video');
      playButton.textContent = '▶';
      wrap.appendChild(playButton);
    } else {
      var image = document.createElement('img');
      image.src = safeMediaUrl(item.src);
      image.alt = alt;
      image.className = 'hh-pdp__gallery-image';
      image.loading = index === 0 ? 'eager' : 'lazy';
      image.width = 1000;
      image.height = 1000;
      wrap.appendChild(image);
    }
    return wrap;
  }

  function buildThumbLabel(item, index, total, productTitle) {
    var kind = item.type === 'video' ? 'video' : item.type === 'placeholder' ? 'placeholder' : 'image';
    var label = 'Show ' + kind + ' ' + (Number(index) + 1) + ' of ' + total;
    var alt = String(item.alt || productTitle || '').trim();
    return alt ? label + ': ' + alt : label;
  }

  function buildThumbNode(item, index, isActive, total, productTitle) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'hh-pdp__gallery-thumb' + (isActive ? ' is-active' : '');
    button.setAttribute('data-hh-pdp-gallery-thumb', '');
    button.setAttribute('data-index', String(index));
    button.setAttribute('role', 'tab');
    button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    button.setAttribute('aria-label', buildThumbLabel(item, index, total, productTitle));

    if (item.type === 'placeholder') {
      var placeholder = document.createElement('div');
      placeholder.className = 'hh-pdp__gallery-placeholder';
      button.appendChild(placeholder);
    } else {
      var img = document.createElement('img');
      img.src = safeMediaUrl(item.type === 'video' ? item.poster : item.src);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 120;
      img.height = 120;
      button.appendChild(img);
    }
    return button;
  }

  // Repaints the mobile next-image teaser with a cropped sliver of the
  // NEXT real selected-pack image/poster (never a gradient), relative to
  // whichever index is currently active. Hidden outright for a single item.
  function updateGalleryTeaser(teaserEl, items, activeIndex) {
    if (!teaserEl) return;
    if (!items || items.length <= 1) {
      teaserEl.hidden = true;
      teaserEl.style.backgroundImage = '';
      return;
    }
    var nextIndex = (Number(activeIndex) + 1) % items.length;
    var nextItem = items[nextIndex];
    var src =
      nextItem && nextItem.type !== 'placeholder'
        ? safeMediaUrl(nextItem.type === 'video' ? nextItem.poster : nextItem.src)
        : '';
    if (!src) {
      teaserEl.hidden = true;
      teaserEl.style.backgroundImage = '';
      return;
    }
    teaserEl.hidden = false;
    // JSON.stringify produces a quoted, backslash/quote-escaped string
    // literal, which is also safe to embed inside a CSS url(...) value.
    teaserEl.style.backgroundImage = 'url(' + JSON.stringify(src) + ')';
  }

  function updateGalleryCaption(captionEl, item, productTitle, isPlaying) {
    if (!captionEl || !item) return;
    captionEl.textContent = item.type === 'video'
      ? (isPlaying ? 'Pause product video' : 'Play product video')
      : (item.alt || productTitle || 'Product photo');
  }

  function toggleNavVisibility(prevBtn, nextBtn, count) {
    var hide = !count || count <= 1;
    if (prevBtn) prevBtn.hidden = hide;
    if (nextBtn) nextBtn.hidden = hide;
  }

  function pauseAllVideos(container) {
    if (!container || !container.querySelectorAll) return;
    container.querySelectorAll('[data-hh-pdp-gallery-item]').forEach(function (node) {
      if (node.__hhPdpDispose) {
        node.__hhPdpDispose();
      } else if (node.__hhPdpReset) {
        node.__hhPdpReset();
      }
    });
    container.querySelectorAll('.hh-pdp__gallery-video').forEach(function (video) {
      if (typeof video.pause === 'function') video.pause();
      if (video.hasAttribute('src')) {
        video.removeAttribute('src');
        video.preload = 'none';
        if (typeof video.load === 'function') video.load();
      }
    });
  }

  function renderGallery(mainEl, thumbsEl, teaserEl, items, galleryRoot, captionEl, prevBtn, nextBtn) {
    if (!mainEl || !items || items.length === 0) return;
    var productTitle = galleryRoot ? galleryRoot.getAttribute('data-product-title') : '';

    // Changing gallery/pack must never leave a previous pack's video
    // playing in the background.
    pauseAllVideos(mainEl);

    mainEl.querySelectorAll('[data-hh-pdp-gallery-item]').forEach(function (node) {
      node.parentNode.removeChild(node);
    });
    items.forEach(function (item, index) {
      var node = buildItemNode(item, index, index === 0, productTitle);
      mainEl.appendChild(node);
      if (item.type === 'video') wireVideoItem(node, captionEl, productTitle);
    });

    if (thumbsEl) {
      while (thumbsEl.firstChild) thumbsEl.removeChild(thumbsEl.firstChild);
      if (items.length > 1) {
        items.forEach(function (item, index) {
          var thumb = buildThumbNode(item, index, index === 0, items.length, productTitle);
          thumbsEl.appendChild(thumb);
        });
        thumbsEl.scrollLeft = 0;
      }
    }

    updateGalleryTeaser(teaserEl, items, 0);
    updateGalleryCaption(captionEl, items[0], productTitle, false);
    toggleNavVisibility(prevBtn, nextBtn, items.length);
  }

  function showIndex(mainEl, thumbsEl, index, items, teaserEl, captionEl, productTitle) {
    mainEl.querySelectorAll('[data-hh-pdp-gallery-item]').forEach(function (item) {
      var isActive = item.getAttribute('data-index') === String(index);
      item.classList.toggle('is-active', isActive);
      if (!isActive) {
        // Pause whatever just became inactive and reset it to its poster,
        // so it never keeps autoplaying off-screen and starts fresh (poster
        // first) the next time it becomes active.
        if (item.__hhPdpReset) {
          item.__hhPdpReset();
        } else {
          var video = item.querySelector('.hh-pdp__gallery-video');
          var poster = item.querySelector('.hh-pdp__gallery-poster');
          if (video) {
            video.pause();
            video.hidden = true;
          }
          if (poster) poster.hidden = false;
          if (item.__hhPdpSetPlaying) item.__hhPdpSetPlaying(false);
        }
      }
    });
    if (thumbsEl) {
      thumbsEl.querySelectorAll('[data-hh-pdp-gallery-thumb]').forEach(function (thumb) {
        var isActive = thumb.getAttribute('data-index') === String(index);
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }
    updateGalleryTeaser(teaserEl, items, index);
    updateGalleryCaption(captionEl, items[Number(index)], productTitle, false);
    var activeVideoItem = mainEl.querySelector('[data-hh-pdp-gallery-item].is-active');
    if (activeVideoItem && activeVideoItem.getAttribute('data-type') === 'video' && activeVideoItem.__hhPdpResume) {
      activeVideoItem.__hhPdpResume();
    }
  }

  function wireVideoItem(item, captionEl, productTitle) {
    var poster = item.querySelector('.hh-pdp__gallery-poster');
    var video = item.querySelector('.hh-pdp__gallery-video');
    var playButton = item.querySelector('[data-hh-pdp-play]');
    var attached = false;
    var isPlaying = false;
    var isInView = false;
    var playPending = false;
    var autoplayBlocked = false;
    var manualPaused = false;
    var mediaFailed = false;
    var posterShown = true;
    var handoffEpoch = 0;
    var handoffVideoFrame = 0;
    var handoffAnimationFrame = 0;
    var handoffPlayingListener = null;
    var maxHandoffFrames = 120;
    var observer = null;
    var domReadyListener = null;
    var visibilityListener = null;
    var errorListener = null;
    var playButtonListener = null;
    var disposed = false;
    var isOnScreen = false;
    var autoIdleHandle = 0;
    var autoTimer = 0;
    var canplayListener = null;
    var autoIdleTimeout = 2000;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function attachVideo() {
      if (attached || !video) return;
      if (disposed || item.isConnected === false) return;
      var src = selectHeroVideoSource(item);
      if (!src) return;
      video.setAttribute('src', src);
      attached = true;
    }

    function setPlaying(playing) {
      isPlaying = playing;
      if (!playing) cancelAutoWork();
      if (playButton) {
        playButton.textContent = playing ? '❚❚' : '▶';
        playButton.setAttribute('aria-label', playing ? 'Pause product video' : 'Play product video');
        playButton.setAttribute('aria-pressed', playing ? 'true' : 'false');
      }
      if (item.isConnected !== false && item.classList.contains('is-active')) {
        updateGalleryCaption(captionEl, { type: 'video' }, productTitle, playing);
      }
    }
    item.__hhPdpSetPlaying = setPlaying;

    function cancelHandoff() {
      handoffEpoch++;
      if (handoffVideoFrame && video && typeof video.cancelVideoFrameCallback === 'function') {
        video.cancelVideoFrameCallback(handoffVideoFrame);
      }
      handoffVideoFrame = 0;
      if (handoffAnimationFrame && typeof window.cancelAnimationFrame === 'function') {
        window.cancelAnimationFrame(handoffAnimationFrame);
      }
      handoffAnimationFrame = 0;
      if (handoffPlayingListener && video) {
        video.removeEventListener('playing', handoffPlayingListener);
      }
      handoffPlayingListener = null;
    }

    function revertToPoster() {
      cancelHandoff();
      if (poster) poster.hidden = false;
      posterShown = true;
      if (video) video.hidden = true;
    }

    function resetToPoster() {
      if (video && typeof video.pause === 'function') video.pause();
      playPending = false;
      revertToPoster();
      setPlaying(false);
    }
    item.__hhPdpReset = resetToPoster;

    function handOffToVideo(epoch) {
      if (epoch !== handoffEpoch) return;
      if (disposed || item.isConnected === false || !item.classList.contains('is-active')) return;
      if (document.visibilityState === 'hidden') return;
      // Offscreen guard only when an observer tracks visibility; without
      // IntersectionObserver a manual Play must still reveal.
      if (observer && !isOnScreen) return;
      if (poster) poster.hidden = true;
      posterShown = false;
    }

    function videoHasFrame() {
      return video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0;
    }

    function awaitFirstVideoFrame(epoch, framesLeft) {
      if (epoch !== handoffEpoch) return;
      if (typeof video.requestVideoFrameCallback === 'function') {
        handoffVideoFrame = video.requestVideoFrameCallback(function () {
          handoffVideoFrame = 0;
          handOffToVideo(epoch);
        });
        return;
      }
      if (typeof window.requestAnimationFrame !== 'function') {
        if (videoHasFrame()) handOffToVideo(epoch);
        return;
      }
      if (framesLeft <= 0) return;
      handoffAnimationFrame = window.requestAnimationFrame(function () {
        handoffAnimationFrame = 0;
        if (epoch !== handoffEpoch) return;
        if (videoHasFrame()) {
          handOffToVideo(epoch);
          return;
        }
        awaitFirstVideoFrame(epoch, framesLeft - 1);
      });
    }

    function reallyPlayVideo(manual) {
      if (disposed || item.isConnected === false) return;
      if (!item.classList.contains('is-active')) return; // never autoplay an inactive item
      if (isPlaying || playPending) return;
      if (!manual && autoplayBlocked) return;
      attachVideo();
      if (!video) return;
      cancelHandoff();
      var epoch = handoffEpoch;
      video.hidden = false;
      // Poster stays visible (both elements share the same poster image,
      // and the <img> is still the one shown) until the browser actually
      // starts playback — not merely once .play() has been called/resolved,
      // which can still precede real frames rendering.
      handoffPlayingListener = function onPlaying() {
        handoffPlayingListener = null;
        if (epoch !== handoffEpoch) return;
        if (item.isConnected === false || !item.classList.contains('is-active')) {
          resetToPoster();
          return;
        }
        setPlaying(true);
        awaitFirstVideoFrame(epoch, maxHandoffFrames);
      };
      video.addEventListener('playing', handoffPlayingListener, { once: true });
      playPending = true;
      video.play().then(
        function () {
          if (epoch !== handoffEpoch) return;
          playPending = false;
        },
        function (err) {
          if (epoch !== handoffEpoch) return;
          playPending = false;
          if (err && err.name === 'NotAllowedError') {
            autoplayBlocked = true;
            cancelAutoWork();
          }
          if (item.isConnected === false) return;
          revertToPoster();
          setPlaying(false);
        }
      );
    }

    function autoEligible() {
      return !disposed && item.isConnected !== false && item.classList.contains('is-active') &&
        !isPlaying && !playPending && !manualPaused && !autoplayBlocked && !mediaFailed &&
        !reduceMotion && isInView && document.visibilityState !== 'hidden';
    }

    function cancelAutoWork() {
      if (autoIdleHandle && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(autoIdleHandle);
      }
      autoIdleHandle = 0;
      if (autoTimer) window.clearTimeout(autoTimer);
      autoTimer = 0;
      if (canplayListener && video) video.removeEventListener('canplay', canplayListener);
      canplayListener = null;
      if (domReadyListener) {
        window.removeEventListener('DOMContentLoaded', domReadyListener);
        domReadyListener = null;
      }
    }

    function runAutoAttach() {
      autoIdleHandle = 0;
      autoTimer = 0;
      if (!autoEligible() || !video) return;
      var fresh = !attached;
      attachVideo();
      if (!attached) return;
      if (fresh) video.preload = 'auto';
      if (!fresh && video.readyState >= 3) {
        reallyPlayVideo(false);
        return;
      }
      if (!canplayListener) {
        canplayListener = function () {
          canplayListener = null;
          if (autoEligible()) reallyPlayVideo(false);
        };
        video.addEventListener('canplay', canplayListener, { once: true });
      }
      // Opt into buffering only once gated; SSR markup ships preload="none".
      if (fresh && typeof video.load === 'function') video.load();
    }

    function scheduleAutoAttach() {
      if (autoIdleHandle || autoTimer || canplayListener) return;
      if (typeof window.requestIdleCallback === 'function') {
        autoIdleHandle = window.requestIdleCallback(runAutoAttach, { timeout: autoIdleTimeout });
      } else {
        autoTimer = window.setTimeout(runAutoAttach, 200);
      }
    }

    function playVideo(manual) {
      if (disposed || item.isConnected === false) return;
      if (isPlaying || playPending) return;
      if (!manual && (manualPaused || autoplayBlocked || mediaFailed)) return;
      if (!manual && (reduceMotion || !isInView || document.visibilityState === 'hidden')) return;
      if (manual) {
        cancelAutoWork();
        autoplayBlocked = false;
        manualPaused = false;
        reallyPlayVideo(true);
        return;
      }
      if (document.readyState === 'interactive' || document.readyState === 'complete') {
        scheduleAutoAttach();
      } else {
        if (domReadyListener) return;
        domReadyListener = function () {
          domReadyListener = null;
          playVideo(false);
        };
        window.addEventListener('DOMContentLoaded', domReadyListener, { once: true });
      }
    }
    item.__hhPdpResume = function () { playVideo(false); };

    function disposeVideoItem() {
      disposed = true;
      cancelAutoWork();
      resetToPoster();
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      if (domReadyListener) {
        window.removeEventListener('DOMContentLoaded', domReadyListener);
        domReadyListener = null;
      }
      if (visibilityListener) {
        document.removeEventListener('visibilitychange', visibilityListener);
        visibilityListener = null;
      }
      if (video && errorListener) {
        video.removeEventListener('error', errorListener);
        errorListener = null;
      }
      if (playButton && playButtonListener) {
        playButton.removeEventListener('click', playButtonListener);
        playButtonListener = null;
      }
    }
    item.__hhPdpDispose = disposeVideoItem;

    if (playButton) {
      playButtonListener = function () {
        if (isPlaying) {
          manualPaused = true;
          video.pause();
          if (posterShown) {
            revertToPoster();
          } else {
            cancelHandoff();
          }
          setPlaying(false);
        } else {
          playVideo(true);
        }
      };
      playButton.addEventListener('click', playButtonListener);
    }

    if (video) {
      errorListener = function () {
        mediaFailed = true;
        resetToPoster();
      };
      video.addEventListener('error', errorListener);
    }

    if (!('IntersectionObserver' in window)) {
      return; // Poster-only; manual play still available via the button.
    }

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          isOnScreen = entry.isIntersecting;
          isInView = entry.isIntersecting && entry.intersectionRatio >= 0.5;
          if (isInView && item.classList.contains('is-active')) {
            // An early manual Play can present its first frame before the
            // observer's first delivery. That guarded handoff keeps the poster;
            // ask for a fresh frame once visible without restarting playback.
            if (isPlaying && posterShown && !handoffVideoFrame && !handoffAnimationFrame) {
              awaitFirstVideoFrame(handoffEpoch, maxHandoffFrames);
            }
            playVideo(false);
          } else if (!isInView) {
            if (isPlaying || playPending) {
              resetToPoster();
            } else {
              cancelAutoWork();
            }
          }
        });
      },
      { threshold: [0, 0.5] }
    );
    observer.observe(item);
    visibilityListener = function () {
      if (document.visibilityState === 'hidden') {
        if (isPlaying || playPending) {
          resetToPoster();
        } else {
          cancelAutoWork();
        }
      } else if (document.visibilityState === 'visible') {
        playVideo(false);
      }
    };
    document.addEventListener('visibilitychange', visibilityListener);
  }

  function readItemsFromDom(mainEl) {
    var result = [];
    mainEl.querySelectorAll('[data-hh-pdp-gallery-item]').forEach(function (node) {
      var type = node.getAttribute('data-type');
      var entry = { type: type };
      if (type === 'video') {
        entry.poster = node.getAttribute('data-poster');
        var video = node.querySelector('.hh-pdp__gallery-video');
        entry.alt = video ? video.getAttribute('aria-label') : '';
      } else if (type !== 'placeholder') {
        var img = node.querySelector('.hh-pdp__gallery-image');
        entry.src = img ? img.getAttribute('src') : '';
        entry.alt = img ? img.getAttribute('alt') : '';
      }
      result.push(entry);
    });
    return result;
  }

  function wireGalleryZoom(root, main, owner) {
    if (typeof HTMLDialogElement === 'undefined') return;
    var labels = root.querySelector('[data-hh-pdp-commerce-labels]');
    var enlargeLabel = labels && labels.getAttribute('data-enlarge-image');
    var closeLabel = labels && labels.getAttribute('data-close-image');
    if (!enlargeLabel || !closeLabel) return;
    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'hh-pdp__gallery-zoom-trigger';
    trigger.textContent = enlargeLabel;
    main.parentNode.appendChild(trigger);
    var dialog = document.createElement('dialog');
    dialog.className = 'hh-pdp__gallery-zoom';
    dialog.setAttribute('aria-label', enlargeLabel);
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'hh-pdp__gallery-zoom-close';
    close.textContent = closeLabel;
    var image = document.createElement('img');
    dialog.appendChild(close);
    dialog.appendChild(image);
    root.appendChild(dialog);
    var returnFocus = null;
    function activeImage() {
      return main.querySelector('[data-hh-pdp-gallery-item].is-active[data-type="image"] .hh-pdp__gallery-image');
    }
    function openImage() {
      var source = activeImage();
      var url = source && safeMediaUrl(source.getAttribute('src'));
      if (!url || dialog.open) return;
      returnFocus = document.activeElement;
      image.src = url;
      image.alt = source.alt;
      dialog.showModal();
      close.focus();
    }
    function syncImage() {
      trigger.hidden = !activeImage();
      if (dialog.open) dialog.close();
    }
    owner.listen(trigger, 'click', openImage);
    owner.listen(main, 'click', function (event) {
      if (event.target === activeImage()) openImage();
    });
    owner.listen(close, 'click', function () { dialog.close(); });
    owner.listen(dialog, 'click', function (event) {
      if (event.target === dialog) dialog.close();
    });
    owner.listen(dialog, 'close', function () {
      image.removeAttribute('src');
      if (returnFocus && returnFocus.isConnected) returnFocus.focus();
      returnFocus = null;
    });
    var observer = new MutationObserver(syncImage);
    observer.observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    owner.onCleanup(function () {
      observer.disconnect();
      if (dialog.open) dialog.close();
      dialog.remove();
      trigger.remove();
    });
    syncImage();
  }

  function wireExistingGallery(root, galleryMap, galleryItemsRef, owner) {
    var main = root.querySelector('[data-hh-pdp-gallery-main]');
    var thumbs = root.querySelector('[data-hh-pdp-gallery-thumbs]');
    var teaser = root.querySelector('[data-hh-pdp-gallery-teaser]');
    var caption = root.querySelector('[data-hh-pdp-gallery-caption]');
    var prevBtn = root.querySelector('[data-hh-pdp-gallery-prev]');
    var nextBtn = root.querySelector('[data-hh-pdp-gallery-next]');
    if (!main) return;

    var productTitle = root.getAttribute('data-product-title') || '';

    main.querySelectorAll('[data-hh-pdp-gallery-item][data-type="video"]').forEach(function (node) {
      wireVideoItem(node, caption, productTitle);
    });

    // The initial items list is whatever the server rendered for the
    // currently selected variant, looked up the same way hh-pdp-universal.js looks
    // up every other per-variant fact, so the teaser/thumb wiring for the
    // first paint stays in lockstep with a later variant-driven rebuild.
    var select = root.querySelector('[data-hh-pdp-variant-select]');
    var activePill = root.querySelector('[data-hh-pdp-variant-pill].is-active');
    var initialVariantId = (select && select.value) || (activePill && activePill.getAttribute('data-variant-id'));
    var items = (galleryMap && initialVariantId && galleryMap[String(initialVariantId)]) || null;
    if (!items) items = readItemsFromDom(main);
    if (galleryItemsRef) galleryItemsRef.items = items;
    toggleNavVisibility(prevBtn, nextBtn, items ? items.length : 0);

    if (thumbs && items) {
      // One delegated handler survives gallery rebuilds without retaining
      // discarded thumbnail nodes, including those made by renderGallery.
      owner.listen(thumbs, 'click', function (event) {
        var thumb = event.target.closest && event.target.closest('[data-hh-pdp-gallery-thumb]');
        if (!thumb || !thumbs.contains(thumb)) return;
        var currentItems = (galleryItemsRef && galleryItemsRef.items) || items;
        showIndex(main, thumbs, thumb.getAttribute('data-index'), currentItems, teaser, caption, productTitle);
      });
    }

    function goToIndex(delta) {
      var currentItems = (galleryItemsRef && galleryItemsRef.items) || items;
      if (!currentItems || currentItems.length <= 1) return;
      var active = main.querySelector('[data-hh-pdp-gallery-item].is-active');
      var currentIndex = active ? Number(active.getAttribute('data-index')) : 0;
      var nextIndex = (currentIndex + delta + currentItems.length) % currentItems.length;
      showIndex(main, thumbs, nextIndex, currentItems, teaser, caption, productTitle);
    }

    if (prevBtn) owner.listen(prevBtn, 'click', function () { goToIndex(-1); });
    if (nextBtn) owner.listen(nextBtn, 'click', function () { goToIndex(1); });
    wireGalleryZoom(root, main, owner);
  }

  // Built from this pack's own `alternatives` handles, already resolved
  // server-side (title/url/price/image/available via all_products[handle])
  // into the [data-hh-pdp-alternatives-map] JSON island — never Shopify's
  // generic product-recommendations endpoint, and never another pack's
  // products.
  function buildAlternativeCard(p) {
    var card = document.createElement('a');
    card.className = 'hh-pdp__alt-card';
    card.href = safeRelativeUrl(p.url);

    if (p.image) {
      var img = document.createElement('img');
      img.className = 'hh-pdp__alt-image';
      img.src = safeMediaUrl(p.image);
      img.alt = p.title || '';
      img.loading = 'lazy';
      img.width = 300;
      img.height = 300;
      card.appendChild(img);
    }

    var title = document.createElement('p');
    title.className = 'hh-pdp__alt-title';
    title.textContent = p.title || '';
    card.appendChild(title);

    var price = document.createElement('p');
    price.className = 'hh-pdp__alt-price';
    price.textContent = p.price_formatted || (p.price != null ? fallbackMoney(p.price) : '');
    card.appendChild(price);

    if (p.available === false) {
      var availability = document.createElement('p');
      availability.className = 'hh-pdp__alt-availability';
      availability.textContent = 'Currently unavailable';
      card.appendChild(availability);
    }

    var cta = document.createElement('span');
    cta.className = 'hh-pdp__alt-cta';
    cta.textContent = 'View product';
    card.appendChild(cta);

    return card;
  }

  // Swaps the alternatives grid to this exact variant's own pack.alternatives
  // keyed by variant id in alternativesMap (the server resolves nothing else:
  // there is no product-id fallback handle list) — hiding the section on
  // a pack switch to an unapproved/no-alternatives variant, and restoring it
  // on switching back, without ever leaking another pack's products.
  function updateAlternatives(mount, alternativesMap, variantId) {
    if (!mount) return;
    var grid = mount.querySelector('[data-hh-pdp-alternatives-grid]');
    if (!grid) return;
    var products = alternativesMap[String(variantId)];
    grid.textContent = '';
    if (!Array.isArray(products) || products.length === 0) {
      mount.hidden = true;
      return;
    }
    products.forEach(function (p) {
      grid.appendChild(buildAlternativeCard(p));
    });
    mount.hidden = false;
  }

  function getSelectedAppstleOffer(root, variantId) {
    var container = root.querySelector('.ab-volume-discount-container');
    if (!container) return null;
    var radio = container.querySelector('[role="radio"][aria-checked="true"]');
    if (!radio) return null;
    var ruleContainer = radio.closest('.ab-volume-discount-rule-container');
    var widgetVariantId = ruleContainer ? ruleContainer.getAttribute('data-selected-variant-id') : null;
    if (String(widgetVariantId) !== String(variantId)) return null;
    var titleEl = radio.querySelector('.ab-volume-discount-item-title-label-v2');
    var subtitleEl = radio.querySelector('.ab-volume-discount-item-save-subtitle-label-v2');
    var quantityMatch = titleEl && /^Buy\s+(\d+)$/i.exec(titleEl.textContent.trim());
    if (!quantityMatch) return null;
    var quantity = Number(quantityMatch[1]);
    if (!Number.isSafeInteger(quantity) || quantity < 1) return null;
    var subtitle = subtitleEl ? subtitleEl.textContent.trim() : '';
    var discountMatch = /^You save\s+(\d+(?:\.\d+)?)%$/i.exec(subtitle);
    var percent = /^Standard Price$/i.test(subtitle) ? 0 : discountMatch ? Number(discountMatch[1]) : NaN;
    if (!Number.isFinite(percent) || percent < 0 || percent > 100) return null;
    return { quantity: quantity, percent: percent };
  }

  // Every recognized, current-variant offer in the live widget, parsed with
  // exactly the same strict rules getSelectedAppstleOffer applies to the
  // checked one (a `Buy N` title, plus a `Standard Price`/`You save N%`
  // subtitle), in the order the app rendered them and with duplicate
  // quantities dropped. A widget that is absent, still showing another
  // variant's rule container, or whose items don't parse yields an empty
  // list — this never invents a tier the app isn't already offering, and it
  // never reads a price or discount out of anything but these same labels.
  function listAppstleOffers(root, variantId) {
    var container = root.querySelector('.ab-volume-discount-container');
    if (!container || variantId == null || variantId === '') return [];
    var radios = container.querySelectorAll('[role="radio"]');
    var offers = [];
    var seen = {};
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      var ruleContainer = radio.closest('.ab-volume-discount-rule-container');
      var widgetVariantId = ruleContainer ? ruleContainer.getAttribute('data-selected-variant-id') : null;
      if (String(widgetVariantId) !== String(variantId)) continue;
      var titleEl = radio.querySelector('.ab-volume-discount-item-title-label-v2');
      var subtitleEl = radio.querySelector('.ab-volume-discount-item-save-subtitle-label-v2');
      var quantityMatch = titleEl && /^Buy\s+(\d+)$/i.exec(titleEl.textContent.trim());
      if (!quantityMatch) continue;
      var quantity = Number(quantityMatch[1]);
      if (!Number.isSafeInteger(quantity) || quantity < 1) continue;
      var subtitle = subtitleEl ? subtitleEl.textContent.trim() : '';
      var discountMatch = /^You save\s+(\d+(?:\.\d+)?)%$/i.exec(subtitle);
      var percent = /^Standard Price$/i.test(subtitle) ? 0 : discountMatch ? Number(discountMatch[1]) : NaN;
      if (!Number.isFinite(percent) || percent < 0 || percent > 100) continue;
      if (seen[quantity]) continue;
      seen[quantity] = true;
      offers.push({ quantity: quantity, percent: percent, radio: radio });
    }
    return offers;
  }

  // Preserve paise in recognized current-variant offer labels. Do not replace
  // React-owned nodes or touch unrecognized widget structures or discounts.
  function updateAppstleExactMoney(root, variant) {
    listAppstleOffers(root, variant.id).forEach(function (offer) {
      var total = computeOfferTotalCents(variant, offer);
      if (!Number.isSafeInteger(total) || total < 0) return;
      var original = variant.price * offer.quantity;
      if (!Number.isSafeInteger(original) || original < total) return;
      var put = function (selector, text) {
        var el = offer.radio.querySelector(selector);
        if (el && el.textContent !== text) el.textContent = text;
      };
      put('.volume-discount-price-v2', inrWholeRupees(total));
      put('.volume-original-price-v2', inrWholeRupees(original));
      var saving = offer.radio.querySelector('.ab-volume-discount-item-save-badge-label-v2');
      if (saving && /^Save\s+(?:Rs\.?|₹)/.test(saving.textContent.trim())) {
        put('.ab-volume-discount-item-save-badge-label-v2', 'Save ' + inrWholeRupees(original - total));
      }
    });
  }

  function computeOfferTotalCents(variant, offer) {
    if (!variant || !offer || !Number.isFinite(variant.price)) return null;
    return Math.round(variant.price * offer.quantity * (1 - offer.percent / 100));
  }

  function findAppstleBuy1Radio(root, variantId) {
    var container = root.querySelector('.ab-volume-discount-container');
    if (!container || variantId == null || variantId === '') return null;
    var radios = container.querySelectorAll('[role="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var ruleContainer = radios[i].closest('.ab-volume-discount-rule-container');
      var widgetVariantId = ruleContainer ? ruleContainer.getAttribute('data-selected-variant-id') : null;
      if (String(widgetVariantId) !== String(variantId)) continue;
      var titleEl = radios[i].querySelector('.ab-volume-discount-item-title-label-v2');
      if (titleEl && /^Buy\s+1$/i.test(titleEl.textContent.trim())) return radios[i];
    }
    return null;
  }

  // Appstle always inserts its offer widget as a sibling immediately before
  // the native <form>, regardless of where the picker sits in the markup.
  // This relocates that same node (never clones/replaces it, so its
  // listeners and internal state survive) to just before the qty row, which
  // keeps it a form descendant and preserves the picker -> offer -> qty/CTA
  // visual order. The move is a no-op once the node is already there, so the
  // root-level MutationObserver that triggers attachCurrentWidget on every
  // childList change (including the move itself) can't loop.
  function relocateOfferWidget(root, container) {
    if (!container) return;
    var form = root.querySelector('[data-hh-pdp-form]');
    var qtyRow = root.querySelector('[data-hh-pdp-qty-row]');
    if (!form || !qtyRow) return;
    relabelOfferHeading(container);
    if (container.parentNode === form && container.nextSibling === qtyRow) return;
    form.insertBefore(container, qtyRow);
  }

  // The approved shared heading reads "Quantity / volume offers", not
  // Appstle's own default "Buy More, Save More!" copy. Scoped to the exact
  // live-DOM header label class, inside .hh-pdp only, and a no-op once
  // already relabelled — so the MutationObserver watching this same
  // container for schedule()/attachCurrentWidget() never loops on its own
  // text-node edit.
  function relabelOfferHeading(container) {
    if (!container || !container.closest('.hh-pdp')) return;
    var label = container.querySelector('.ab-volume-discount-header-label');
    if (!label) return;
    var approvedHeading = 'Quantity / volume offers';
    if (label.textContent.trim() === approvedHeading) return;
    if (label.textContent.trim() === 'Buy More, Save More!') {
      label.textContent = approvedHeading;
    }
  }

  function initAppstleOfferObserver(root, refresh, getVariantId, owner) {
    if (typeof MutationObserver === 'undefined') return;
    var attachedTo = null;
    var widgetObserver = null;
    var pending = false;
    var deferredHandle = null;
    var useAnimationFrame = typeof window.requestAnimationFrame === 'function';
    var userChose = root.__hhPdpOfferUserChose === true;
    var defaultedRadio = null;
    var defaultedVariantId = null;
    var defaultAttempts = 0;
    var DEFAULT_ATTEMPT_LIMIT = 4;

    function noteUserChoice(event) {
      if (!event.isTrusted) return;
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      var choice = target.closest('[role="radio"]');
      if (!choice || !choice.closest('.ab-volume-discount-container')) return;
      userChose = true;
      root.__hhPdpOfferUserChose = true;
    }

    // The compact Qty select asks the app for a tier by clicking the
    // original matching radio, and that synthetic click is isTrusted ===
    // false — exactly what noteUserChoice above is meant to ignore. This
    // capture-phase listener is what records the shopper's real choice
    // instead. It is registered here, before any such control is built,
    // and capture on an ancestor always runs ahead of the select's own
    // target-phase change handler, so userChose is already set by the
    // time the synthetic click is dispatched; without it, applyDefaultOffer
    // would snap a deliberate Buy 2/4 back to Buy 1.
    //
    // Deliberately no isTrusted gate here, unlike the default-offer
    // click/keydown trust checks: Safari's native select accessibility and
    // keyboard paths (and VoiceOver/assistive or integration drivers) can
    // deliver an untrusted-looking change for a genuine selection, which
    // used to be dropped and reset to Buy 1. Any explicit change event on
    // this one compact select counts as a choice. This stays safe because
    // our own state sync only assigns select.value and never dispatches
    // change, so a programmatic value repaint still marks nothing.
    owner.listen(root, 'change', function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest('[data-hh-pdp-qty-compact-select]')) return;
      userChose = true;
      root.__hhPdpOfferUserChose = true;
    }, true);
    owner.listen(root, 'click', noteUserChoice, true);
    owner.listen(root, 'keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
      noteUserChoice(event);
    }, true);

    function applyDefaultOffer() {
      if (userChose || typeof getVariantId !== 'function') return;
      var variantId = getVariantId();
      var radio = findAppstleBuy1Radio(root, variantId);
      if (!radio) return;
      if (radio !== defaultedRadio || String(defaultedVariantId) !== String(variantId)) {
        defaultedRadio = radio;
        defaultedVariantId = variantId;
        defaultAttempts = 0;
      }
      if (radio.getAttribute('aria-checked') === 'true') return;
      if (defaultAttempts >= DEFAULT_ATTEMPT_LIMIT) return;
      defaultAttempts++;
      radio.click();
      if (radio.getAttribute('aria-checked') !== 'true' && defaultAttempts < DEFAULT_ATTEMPT_LIMIT) schedule();
    }

    function schedule() {
      if (owner.destroyed || pending) return;
      pending = true;
      var defer = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 0); };
      deferredHandle = defer(function () {
        deferredHandle = null;
        pending = false;
        if (owner.destroyed) return;
        applyDefaultOffer();
        refresh();
      });
    }

    function attachCurrentWidget() {
      if (owner.destroyed) return;
      var container = root.querySelector('.ab-volume-discount-container');
      relocateOfferWidget(root, container);
      if (container === attachedTo) return;
      if (widgetObserver) widgetObserver.disconnect();
      attachedTo = container;
      widgetObserver = null;
      if (container) {
        widgetObserver = new MutationObserver(schedule);
        widgetObserver.observe(container, {
          subtree: true,
          childList: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['aria-checked', 'data-selected-variant-id']
        });
      }
      schedule();
    }

    var rootObserver = new MutationObserver(attachCurrentWidget);
    owner.onCleanup(function () {
      rootObserver.disconnect();
      if (widgetObserver) widgetObserver.disconnect();
      if (deferredHandle !== null) {
        if (useAnimationFrame && typeof window.cancelAnimationFrame === 'function') window.cancelAnimationFrame(deferredHandle);
        else if (!useAnimationFrame) window.clearTimeout(deferredHandle);
      }
      attachedTo = null;
      widgetObserver = null;
      deferredHandle = null;
      pending = false;
    });
    attachCurrentWidget();
    rootObserver.observe(root, { childList: true, subtree: true });
  }

  // --- Review-anchor navigation, shared by the server render and the
  // variant rebuild. ---
  //
  // Two ids resolve to the one Customer reviews disclosure and both have to
  // work: the public '#product-reviews' that the collection/product rating
  // links and assets/scripts.js have always used, and this section's own
  // per-section '#hh-pdp-reviews-<sectionId>'. That disclosure is a closed
  // <details>, so a plain fragment navigation reveals nothing by itself.
  // Nothing here reads, duplicates or renders any review content: it only
  // opens and scrolls to the one disclosure the app's list is mounted in.
  var HH_REVIEWS_DISCLOSURE_PREFIX = 'hh-pdp-reviews-';

  function matchesReviewAnchor(hash, reviewAnchorId, sectionId) {
    if (typeof hash !== 'string' || !hash) return false;
    var id = hash.charAt(0) === '#' ? hash.slice(1) : hash;
    if (!id) return false;
    try {
      id = decodeURIComponent(id);
    } catch (e) {
      // a malformed escape is simply not one of these two ids
    }
    if (reviewAnchorId && id === reviewAnchorId) return true;
    return !!sectionId && id === HH_REVIEWS_DISCLOSURE_PREFIX + sectionId;
  }

  function openReviewsDisclosure(scope, shouldScroll) {
    var reviewsNode = scope && typeof scope.querySelector === 'function'
      ? scope.querySelector('[data-hh-pdp-kind="reviews"]')
      : null;
    if (!reviewsNode) return false;
    reviewsNode.open = true;
    if (shouldScroll && typeof reviewsNode.scrollIntoView === 'function') {
      reviewsNode.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    return true;
  }

  // Keeps exactly one element carrying the public review-anchor id: the
  // server-rendered one is re-appended on every pack rebuild, and a new one is
  // created only when that id is not already in the document, so a repeated
  // render can never leave two nodes sharing it. The id itself comes from
  // sections/hh-pdp.liquid, which renders this same element server-side.
  function appendReviewAnchorAlias(parent, existing, reviewAnchorId, doc) {
    if (!parent || !reviewAnchorId) return null;
    if (existing) {
      parent.appendChild(existing);
      return existing;
    }
    if (!doc || typeof doc.createElement !== 'function') return null;
    if (typeof doc.getElementById === 'function' && doc.getElementById(reviewAnchorId)) return null;
    var alias = doc.createElement('span');
    alias.className = 'hh-pdp__review-anchor';
    alias.id = reviewAnchorId;
    alias.setAttribute('data-hh-pdp-review-anchor', '');
    parent.appendChild(alias);
    return alias;
  }

  // The fallback link's target is the apps-section wrapper whose id Shopify
  // derives from this JSON template, resolved in sections/hh-pdp.liquid. If
  // that wrapper is not on the page the link is removed rather than left
  // pointing at a fragment that does not exist; [hidden] would not hide it,
  // since .hh-pdp__review-fallback sets its own display in assets/hh-pdp-universal.css.
  function syncReviewFallbackLink(link, appAnchor, doc) {
    if (!link) return false;
    var anchor = typeof appAnchor === 'string' ? appAnchor : '';
    var targetId = anchor.charAt(0) === '#' ? anchor.slice(1) : '';
    var target = targetId && doc && typeof doc.getElementById === 'function'
      ? doc.getElementById(targetId)
      : null;
    if (!target) {
      if (link.parentNode && typeof link.parentNode.removeChild === 'function') {
        link.parentNode.removeChild(link);
      }
      return false;
    }
    link.setAttribute('href', anchor);
    return true;
  }

  function initReviewAnchorNavigation(root, scope, reviewAnchorId, sectionId, win, owner) {
    if (!scope || typeof scope.querySelector !== 'function') return null;
    var alias = reviewAnchorId ? scope.querySelector('[data-hh-pdp-review-anchor]') : null;
    if (alias) {
      // assets/scripts.js looks this id up and calls .expand() on it for the
      // same navigation; give it the real disclosure instead of a TypeError.
      // It does its own scrolling, so this only opens the disclosure.
      var previousExpand = alias.expand;
      var expand = function () {
        if (owner.destroyed) return;
        openReviewsDisclosure(scope, false);
      };
      alias.expand = expand;
      owner.onCleanup(function () {
        if (alias.expand === expand) {
          if (previousExpand === undefined) delete alias.expand;
          else alias.expand = previousExpand;
        }
      });
    }

    function handleReviewHash() {
      if (owner.destroyed) return false;
      var hash = win && win.location ? win.location.hash : '';
      if (!matchesReviewAnchor(hash, reviewAnchorId, sectionId)) return false;
      return openReviewsDisclosure(scope, true);
    }

    // Initial load (a collection/external link landing on
    // /products/...#product-reviews) plus every later in-page hash change.
    handleReviewHash();
    if (win && typeof win.addEventListener === 'function') {
      owner.listen(win, 'hashchange', handleReviewHash);
    }
    // A review link inside this section that is already on the current hash
    // fires no hashchange, so handle the activation too. A real link or
    // button fires 'click' on Enter/Space, so this stays keyboard-operable
    // without its own keydown handling, same as the rating handler above.
    if (root && typeof root.addEventListener === 'function') {
      owner.listen(root, 'click', function (event) {
        var target = event && event.target;
        var link = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
        if (!link || typeof link.getAttribute !== 'function') return;
        var href = link.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex === -1) return;
        if (!matchesReviewAnchor(href.slice(hashIndex), reviewAnchorId, sectionId)) return;
        // Same-document links only: a rating link to another product must
        // still navigate there instead of opening this product's reviews.
        var linkPath = href.slice(0, hashIndex).split('?')[0];
        if (linkPath !== '' && !(win && win.location && linkPath === win.location.pathname)) return;
        openReviewsDisclosure(scope, true);
      });
    }
    return handleReviewHash;
  }

  // Moves the AreviewsDisplayReviews app's own #AreviewsContainer (rendered
  // by the separate "apps" section in product.hh-custom.json, elsewhere on
  // the page, outside `root`) into the Customer reviews disclosure's slot.
  // No review/rating data is read or duplicated here — this only relocates
  // the app's own element. If the app hasn't rendered it yet, the slot's
  // fallback link (wired in Liquid/buildReviewsNode) stays visible and
  // still points somewhere real; a MutationObserver keeps watching so a
  // late-arriving app still ends up mounted without a page reload.
  function initReviews(root, owner) {
    var slot = root.querySelector('[data-hh-pdp-review-slot]');
    if (!slot) return;
    var mounted = false;
    var container = null;
    var origin = null;
    var nextSibling = null;
    var observer = null;
    owner.onCleanup(function () {
      if (observer) observer.disconnect();
      // Return the app's actual node to its original apps section before
      // Shopify discards the old PDP. Never clone app markup or listeners.
      if (container && slot.contains(container) && origin && origin.isConnected !== false && !root.contains(origin)) {
        origin.insertBefore(container, nextSibling && nextSibling.parentNode === origin ? nextSibling : null);
      }
      slot.classList.remove('is-mounted');
    });

    function tryMount() {
      if (owner.destroyed) return false;
      if (mounted) return true;
      container = typeof document.getElementById === 'function' ? document.getElementById('AreviewsContainer') : null;
      if (!container) return false;
      var owningPdp = typeof container.closest === 'function' ? container.closest('[data-hh-pdp]') : null;
      if (owningPdp && owningPdp !== root) return false;
      origin = container.parentNode;
      nextSibling = container.nextSibling;
      slot.appendChild(container);
      mounted = true;
      slot.classList.add('is-mounted');
      return true;
    }

    if (tryMount()) return;
    if (typeof MutationObserver !== 'undefined' && document.body) {
      observer = new MutationObserver(function () {
        if (tryMount()) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  function mount(scope) {
    if (!scope) return;
    if (typeof scope.matches === 'function' && scope.matches('[data-hh-pdp]')) init(scope);
    if (typeof scope.querySelectorAll === 'function') scope.querySelectorAll('[data-hh-pdp]').forEach(init);
  }
  function unmount(scope) {
    ownedRoots.slice().forEach(function (root) {
      if (scope === root || (scope && scope.contains && scope.contains(root))) root.__hhPdpController.destroy();
    });
  }
  window.__hhPdpRuntime = { mount: mount, unmount: unmount };
  if (typeof document.addEventListener === 'function') {
    document.addEventListener('shopify:section:load', function (event) { mount(event.target); });
    document.addEventListener('shopify:section:unload', function (event) { unmount(event.target); });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  }
  document.querySelectorAll('[data-hh-pdp]').forEach(init);
})();

